(() => {
  let Carambola = {
    params: { 
      render: false, 
      cdn: "https://units.carambo.la", 
      cbolaWheelEventEndTimeout: null, 
      cbolaActiveElementTimeout: null, 
      second: window.performance && performance.now ? performance.now() : (new Date()).getTime(), 
      timer: 5, 
      carouselTimeout: null,
      currentPost: 0,
      clientVersion: 1,
      uuid: Date.now() + Math.random().toString(36).slice(2, 9),
      abtest: Math.random() < 0.05 ? 1 : 2,
      contentCountArr: [],
      contentCount: 0,
      adCount: 0,
      totalHover: 0,
      dwellTime: 0,
      dwellTimeEmbed: 0,
      onePost: false,
      clicked: false,
      lazyload: false,
      noAds: false,
      outOfFrameShow: true,
      widgetLoad: false
    },
    viewport: { unitViewport: false, unitViewportTime: null, currentOffset: 0, order: 1 },
    slider: { current: 0, currentPos: null, mouseOffset: null, moving: false, startPos: null, lastTouchX: null, swipped: false },
    ads: [],
    content: [],
    files: [],
    default: {},
    teleport: []
  };

  Carambola.init = async () => {
    Carambola.params.cdn = (document.currentScript.src.includes("dev-units.") || document.currentScript.src.includes("dev-route.") || window.top.location.host === "localhost:3000") ? "https://dev-units.carambo.la" : "https://units.carambo.la";
    Carambola.params.currentScript = document.currentScript;
    Carambola.params.scriptSRC = document.currentScript.src;
    var urlParams = Carambola.getParamsFromUrl(document.currentScript.src), 
          { pid, did, wid } = urlParams,
          hostname = window.top.location.href.toLowerCase(),
          isMobile = Carambola.isMobile(); 

    

    try {
      if (window.top.document.querySelector("#carambola-static-on-page")) {
        try {          
          if(did === "113258"){
            const unitElement = window.top.document.querySelectorAll('#goal_Lists_Carambola_Social');
            if (unitElement.length > 1) {
              unitElement.forEach((el, index) => {
                if (index > 0) el.remove();
              });
            }
          }
        } catch (error) {}

        return false;
      }
    } catch (error) {
      console.log("Unable to access window.top.document due to cross-origin restrictions.");
    }

    if(!pid && !wid && !did) {
      try {
        const wphostsRes = await fetch(`${Carambola.params.cdn}/social/wphosts.json`),
              wphostsJson = await wphostsRes.json();
  
        urlParams = wphostsJson.wphosts.find(el => el.sitename === window.top.location.host.replace(/^www\./, '') && el.platform === ((isMobile) ? "mobile" : "desktop"));
        if(typeof urlParams === "undefined") throw("No match in wphosts file!");
        Carambola.params = { ...Carambola.params, ...urlParams };     
        pid = urlParams?.pid;
        did = urlParams?.did;
        wid = urlParams?.wid;
      } catch (error) {
        console.log("WordPress settings error: ", error);
        return false;
      }
    }
    else if ((did === "112845" && wid === "2") || (did === "112846" && wid === "6")) {
      wid = "12";
      Carambola.params.wid = "12";
    }
    else if (did === "112565") {
      wid = "5";
      Carambola.params.wid = "5";
    }
    else if (did === "112847") {
      wid = "2";
      Carambola.params.wid = "2";
    }    
    else if (did === "112969") {
      wid = "3";
      Carambola.params.wid = "3";
    }  

    const fetchAdUrl = (window.top.location.host === "localhost:3000" || window.top.location.host === "10.0.0.7:3000") ? `http://${window.top.location.host}/ad${wid}.json` : `${Carambola.params.cdn}/general_settings/${pid}/${did.slice(2,did.length)}/wi_${wid}.json`,
          request = await fetch(fetchAdUrl);
          
    if(request.status < 200 || request.status >= 300) {
      console.warn("No main JSON file");
      return false;
    }

    const response = await request.json(),
          generalSetting = response.filter(element => element.type === "General Settings" &&
                                                    element.hasOwnProperty("pid") && element.hasOwnProperty("did") && element.hasOwnProperty("wid") && 
                                                    element.pid.toString() === pid && 
                                                    `11${element.did}` === did && 
                                                    element.wid.toString() === wid);

    if(generalSetting.length === 0) {
      console.warn("No general settings found");
      return false;
    }
    else if(did === "112845" && wid === "10" && isMobile){ 
      return false;
    }
    else {
      if(isMobile && generalSetting[0]?.mobile_layout){
        Carambola.params.layout = generalSetting[0]?.mobile_layout;
        generalSetting[0].layout = Carambola.params.layout;
      }

      if (generalSetting[0]?.hideUnitInUrls?.length > 0) {
        const hideUnit = generalSetting[0].hideUnitInUrls.some(unitUrl => window.top.location.href.startsWith(unitUrl));
        if(hideUnit) return false;
      }

      const contentSpotConfigs = response.filter(element => element.type && element.type === "Content Spot Configs");
      if(contentSpotConfigs.length > 0) { 
        const timer = contentSpotConfigs[0]?.timer;
        if(timer) Carambola.params.timer = timer;
      }
    }

    const followObject = response.find(item => item.hasOwnProperty("widget_follow_object"));
    if (followObject) {
      const { social_follow_link, social_follow_placement, social_follow_abtest } = followObject.widget_follow_object;
      let fabtest = 2;
      if (typeof social_follow_abtest !== 'undefined' && Number.isFinite(social_follow_abtest) && social_follow_abtest > 0) {
        fabtest = (Math.random() <= (social_follow_abtest / 100)) ? 1 : 2;
      }
      Carambola.params = { ...Carambola.params, socialFollowLink: social_follow_link, socialFollowPlacement: social_follow_placement, socialFollowAbtest: fabtest };
    }

    const widgetDesign = response.find(item => item.hasOwnProperty("widget_design"));
    if (widgetDesign) {
      Carambola.params = { ...Carambola.params, ...widgetDesign.widget_design };
    }

    Carambola.params = {...Carambola.params, ...urlParams, ...generalSetting[0], hostname, isMobile, pageViewId: Carambola.generatePageViewId() };

    Carambola.grumi();

    if(Carambola.params?.teleport && Carambola.params?.teleport_mapping){
      Carambola.teleport = JSON.parse(Carambola.params?.teleport_mapping);
    }

    Carambola.AbTestPageLoad();
    Carambola.ads = (Carambola.params.noAds) ? [] : response.filter(element => element.adType && (!element?.platform || element?.platform === ((isMobile) ? "mobile" : "desktop")));
    Carambola.AbTestSticky();
    Carambola.log("PageLoad");

    if(!Carambola.params.active) {
      console.warn("Not active");
      return false;
    }

    const { layout, cdn } = Carambola.params;

    Carambola.renderStyle();
    Carambola.renderUnit();
    
    let cdnPath = window.top.location.host === "localhost:3000" ? `http://localhost:3000/jsons/${did.slice(2,did.length)}_${wid}_${layout}_.json` : `${cdn}/social/social_units/${did.slice(2,did.length)}_${wid}_${layout}_.json`;
    
    if(layout === 160 || layout === 162 || layout === 161 || layout === 163){
      cdnPath = `${cdn}/social/legacy_twitter/${did.slice(2,did.length)}_${wid}.json`;
    }
    else if(layout === 152) {
      cdnPath = `${cdn}/full_content/${pid}_${did}_${layout}_${wid}_content.json`;
    }

    try {      
      if(did === "113278"){
        const mappingRequest = await fetch(`${Carambola.params.cdn}/social/social_content_mapping/sportingnews_mapping.json`),
              mappingJson = await mappingRequest.json(),
              mappingFiltered = Carambola.filterMapping(mappingJson),
              fullListArr = await Carambola.buildList(mappingFiltered);

        if(fullListArr.length < 10){
          const cdnPathRequest = await fetch(cdnPath),
                cdnPathJson = await cdnPathRequest.json();
          fullListArr.push(...cdnPathJson.Items.slice(0, 10 - fullListArr.length));
        }

        Carambola.content = {
          Items: fullListArr,
          Category: 0,
          Domain: did,
          Status: 1,
          DefaultSettings: {
            Layouts: [{ ItemType: 20, LayoutType: layout }]
          },
          DomainCategoryMapping: []
        };

        Carambola.content.Items = Carambola.shuffle(fullListArr);
        Carambola.parseResponse(Carambola.content.Items);
        return false;
      }
    } catch (error) {
      console.log(error);
    }

    fetch(cdnPath).then(async res => {
        if (res.status >= 200 && res.status < 300) {
            const content = await res.json();

            if(content?.DomainCategoryMapping && content.DomainCategoryMapping.length > 0){
              let newFetchArr = content.DomainCategoryMapping.filter(el => (hostname.toLocaleLowerCase().includes((window.top.location.host + el.domain_category_publisher_domain_url).toLocaleLowerCase())));
              if(newFetchArr.length === 0) newFetchArr = content.DomainCategoryMapping.filter(el => (el.domain_category_all_domain_pages && window.top.location.host.toLocaleLowerCase().includes((el.domain_category_publisher_domain_url).toLocaleLowerCase())));
              
              if(newFetchArr.length > 0) {
                const fetchNewUrl = newFetchArr[0].domain_category_json;
                const fetchNewItems = await fetch(fetchNewUrl);
                if(fetchNewItems.status >= 200 && fetchNewItems.status < 300){
                  const fetchNewItemsJson = await fetchNewItems.json();
                  content.Items = fetchNewItemsJson.Items;
                }
                else {
                  throw("Error fetch DomainCategoryMapping!");
                }
              }
            }

            if (generalSetting[0]?.social_feed_mapping) {
              const mappingItemsUrl = `${cdn}/social/social_feed_by_account/Mapping_Items.json`,
                    mappingItemsRes = await fetch(mappingItemsUrl),
                    mappingItemsJson = await mappingItemsRes.json(),
                    newItems = await Carambola.goalMapping(mappingItemsJson);

              if (newItems && newItems.length > 0) {
                content.Items = newItems;
              }
            }

            if(content.Items.length === 0) throw("No items found");
            if(layout !== 160 && layout !== 162 && layout !== 161 && layout !== 163 && layout !== 152 && content.DefaultSettings.Layouts.filter(ltype => ltype.LayoutType === layout).length === 0) throw("Not the right JSON file response");
            Carambola.content = content;
            if(layout === 211 || layout === 202 || layout === 201 || layout === 161 || layout === 162 || layout === 163){
              Carambola.content.Items = Carambola.shuffle(Carambola.content.Items);
            }
            Carambola.parseResponse(content.Items);
        }
        else {
          throw("No content JSON file!");
        }
    }).catch(async (e) => {
      console.warn(`Error fetch url: ${cdnPath} `, e);
      const defaultRes = await fetch(`${cdn}/social/default.json`),
            defaultJson = await defaultRes.json();
    
      Carambola.default = defaultJson;
      Carambola.jsonError();
    });
  };

  Carambola.buildList = async(mappingFiltered) => {
    const fullListArr = [];

    if (mappingFiltered.length > 0) {
      for (const el of mappingFiltered) {
        const res      = await fetch(el.json_content_url);
        const itemJson = await res.json();
        fullListArr.push(...itemJson.Items.slice(0, el.num_items));
      }
    }

    return fullListArr;
  }

  Carambola.filterMapping = (mapping) => {
    const href = window.top.location.href.toLowerCase();
    const items = mapping.Mapping_Items || [];
    const tagsInUrl = Array.from(
      new Set(
        items
          .map(item => (item.tag || '').toLowerCase())
          .filter(tag => tag && href.includes(tag))
      )
    );

    if (tagsInUrl.length === 0) return [];

    const results = tagsInUrl.flatMap(tag => {
      const group = items.filter(
        item => (item.tag || '').toLowerCase() === tag
      );

      const langSpecific = group.filter(item => {
        const langField = (item.lang || '').toLowerCase();
        if (langField === 'all') return false;
        const codes = langField.split(',').map(c => `/${c.trim()}/`);
        return codes.some(code => code && href.includes(code));
      });
      return langSpecific.length > 0
        ? langSpecific
        : group.filter(
            item => (item.lang || '').toLowerCase() === 'all'
          );
    });

    return results;
  }

  Carambola.grumi = () => {
    try{
        const { use_geoedge, teleport, did } = Carambola.params;
        const testRandom = Math.random() < 0.5 ? 1 : 0;
        if (use_geoedge && testRandom) {
          var inline = document.createElement('script');
          inline.type = 'text/javascript';
          if(did === 2845 || did === 2846)
          {      
            inline.text = `
              window.grumi = {
                cfg: {},
                key: '733b87f6-ae2e-4b8e-ac66-2241869e92ad'
              };
            `;
          }
          else{
          inline.text = `
            window.grumi = {
              cfg: {
                exclude: new Proxy(
                  { a: 1 },
                  {
                    get: function(target, slotElementId) {
                      try {
                        var slot = googletag
                          .pubads()
                          .getSlots()
                          .find(slot => slot.getSlotElementId() === slotElementId);
                        var adUnitPath = slot.getAdUnitPath();
                        if (adUnitPath.includes('21718562853') || adUnitPath.includes('23178558518')) {
                          return false;
                        }
                        return true;
                      } catch (e) {
                        return true;
                      }
                    }
                  }
                )
              },
              key: '733b87f6-ae2e-4b8e-ac66-2241869e92ad'
            };
          `;
          }
          var external = document.createElement('script');
          external.src = "//rumcdn.geoedge.be/733b87f6-ae2e-4b8e-ac66-2241869e92ad/grumi-ip.js";
          external.async = true;

          if(teleport){
            window.top.document.head.appendChild(inline);
            window.top.document.head.appendChild(external);
          }
          else {
            document.head.appendChild(inline);
            document.head.appendChild(external);
          }
        }
      } 
    catch(err){console.log(err);}      
  }

  Carambola.AbTestSticky = () => {
    const { ab_test_for_bottom_sticky_ad, layout } = Carambola.params,
          abtestSticky = Math.random() < 0.5;

    if ([211, 201, 202, 152].includes(layout) && ab_test_for_bottom_sticky_ad && abtestSticky) {
      Carambola.params.outOfFrameShow = false;
      if (Array.isArray(Carambola.ads)) {
        Carambola.ads = Carambola.ads.filter(
          element => element.adType !== "outOfFrame"
        );
      }
    }
  };

  Carambola.getHeaders = async (url) => {
    const res = await fetch(url, { method: 'HEAD' });
    return res.headers;   
  }

  Carambola.goalMapping = async (list) => {
    const tagList = Array.from(document.querySelectorAll(".component-tag-list .component-tag")).reverse();
    const { did, cdn } = Carambola.params;
  
    let matchUrl = null, items = [];
  
    try {
      tagList.some(tag => { 
        const match = list?.Mapping_Items?.find(el => 
          el?.Tag?.toLowerCase() === tag?.title?.toLowerCase() &&
          el?.Category?.toLowerCase() === tag?.dataset?.type?.toLowerCase() &&
          el?.domain_id === did
        );
        
        if (match) {
          matchUrl = `${cdn}/social/social_feed_by_account/${did}_${match.Tag.toLowerCase()}_${match.Category.toLowerCase()}.json`;
          return true; 
        }
        return false;
      });
  
      if (matchUrl) { 
        const fetchNewItems = await fetch(matchUrl);
        if (fetchNewItems.ok) { 
          const fetchNewItemsJson = await fetchNewItems.json();
          items = fetchNewItemsJson?.Items || [];
        }
      }
    } catch (error) {
      console.log(error);
      return [];
    }
  
    return items; 
  };

  Carambola.getDefaultContent = () => {
    const { layout } = Carambola.params;
    if([211, 201, 202].includes(layout)) return Carambola.default[210];
    else if([160, 161, 162, 163].includes(layout)) return Carambola.default[160];
    else return Carambola.default[layout];
  }

  Carambola.jsonError = () => {
    const { layout } = Carambola.params; 
    let jsonArr = Carambola.getDefaultContent();
    if(layout === 211 || layout === 202 || layout === 201 || layout === 161 || layout === 162 || layout === 163){
      jsonArr = Carambola.shuffle(jsonArr);
    }
    Carambola.parseResponse(jsonArr);
  }

  Carambola.formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000),
          options = {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true
          };

    return date.toLocaleString('en-US', options);
  }

  Carambola.lazyLoadPost = () => {
    const { layout, did, isMobile, wid, container } = Carambola.params;
    if(layout !== 201 && layout !== 202 && layout !== 211) return [];
    const tempArrPageTweets = [], port = Carambola.teleport.filter(el => el.did === `11${did}` && el.wid === `${wid}` && (el.platform === "" || el.platform === null || el.platform === ((isMobile) ? "mobile" : "desktop")));
    if(port.length === 0) return [];

    try {
      const attr = port[0].attribute,socialPost = window.top.document.querySelectorAll(attr);
      if(socialPost.length > 0){
        const pageEmbed = (socialPost.length > 1) ? socialPost[1] : socialPost[0],
              filterBy = pageEmbed.className;

        switch(true) {
          case filterBy.includes("twitter"):
            var parsedUrl, tweetId, firstPageTweet;
    
            if(socialPost.length > 1) {
              if(socialPost[1].classList.contains("twitter-tweet-rendered")) firstPageTweet = socialPost[1];
              else return [];
            }
            else firstPageTweet = socialPost[0];

            if(firstPageTweet.classList.contains("twitter-tweet-rendered")){
              parsedUrl = new URL(firstPageTweet.querySelector("iframe").src);
              tweetId = parsedUrl.searchParams.get("id");
            }
            else return [];

            tempArrPageTweets.push({ "Id": 1999999, "TwitterXCode": `https://twitframe.com/show?url=https://twitter.com/xxxxx/status/${tweetId}` });
            
            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";    
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo){
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              unitAppendTo.style = "";
              unitAppendTo.style.display = "block";
              unitAppendTo.className = "";
              unitAppendTo.innerHTML = "";
              unitAppendTo.append(tempUnit);
            } 

            var blockquoteTwitter = window.top.document.querySelector(`blockquote.twitter-tweet a[href*='${tweetId}']`);
            if(blockquoteTwitter) blockquoteTwitter.parentNode.remove();
            break;
          case filterBy.includes("instagram"):
            var tweetId, firstPageTweet;

            if(socialPost.length > 1) {
              if(socialPost[1].classList.contains("instagram-media-rendered")) firstPageTweet = socialPost[1];
              else return [];
            }
            else firstPageTweet = socialPost[0];

            if(firstPageTweet.classList.contains("instagram-media-rendered")){
              tweetId = firstPageTweet.src.split('embed/')[0];
            }
            else return [];

            tempArrPageTweets.push({ "Id": 1999999, "InstagramCode": tweetId });

            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";      
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo){
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
            } 
    
            firstPageTweet.remove();
            var blockquoteTwitter = window.top.document.querySelector(`blockquote[data-instgrm-permalink^='${tweetId}']`);
            if(blockquoteTwitter) blockquoteTwitter.remove();
            break;
          case filterBy.includes("tiktok"):
            var tweetId, firstPageTweet = pageEmbed;
    
            if(firstPageTweet){
              tweetId = firstPageTweet.dataset.videoId;
            }
            else return [];
            
            tempArrPageTweets.push({ "Id": 1999999, "TikTokCode": `https://www.tiktok.com/embed/v2/${tweetId}` });

            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";      
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo) { 
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
            }
  
            firstPageTweet.remove();
            break;            
        }

      } 
    } catch (error) {
      return [];
    } finally {
      return tempArrPageTweets;
    }
  }

  Carambola.changeChildElementWidth = (currentElement) => {
    const { did } = Carambola.params;
    let parentWrap;

    try {      
      switch(did){
        case 3262:
          Carambola.clear();
          break;
        case 3278:
          const lozadParent = currentElement.closest('.lozad');
          if (lozadParent) lozadParent.classList.add("carambola-lazyload-wrap");
          Carambola.clear();
          break;          
        case 3260:
          parentWrap = currentElement.closest('figure');
  
          if (parentWrap) {
            parentWrap.classList.add("carambola-change-width");
            parentWrap.style.width = "100%";
            parentWrap.style.margin = "0";

            setTimeout(() => {
              currentElement.parentNode.style.display = "block";
            }, 1000);
          }
          else {
            return false;
          }
          Carambola.clear();
          break;
        default:
          return false;
      }
  
      if (parentWrap) {
        const elements = parentWrap.querySelectorAll('*');
      
        elements.forEach(el => {
          el.style.width = '100%';
          el.style.display = 'block';
        });
      }
    } catch (error) {}
  }

  Carambola.clear = () => {
    setTimeout(() => {
      try {
        const staticOnPage = window.top.document.querySelector("#carambola-static-on-page");
        if(staticOnPage){
          const next = staticOnPage?.nextElementSibling;
          if(next && next.tagName.toLowerCase() === 'blockquote' && next.classList.contains("instagram-media-registered")){
            next.remove();
          }
        }
      } catch (error) {}
    }, 1000);
  }

  Carambola.getFirstTweetFromPage = () => {
    const { layout, did, isMobile, wid, container } = Carambola.params;
    if(layout !== 201 && layout !== 202 && layout !== 211) return [];
    const tempArrPageTweets = [], port = Carambola.teleport.filter(el => el.did === `11${did}` && el.wid === `${wid}` && (el.platform === "" || el.platform === null || el.platform === ((isMobile) ? "mobile" : "desktop")));
    if(port.length === 0) return [];

    try {
      const attr = port[0].attribute,socialPost = window.top.document.querySelectorAll(attr);
      if(socialPost.length > 0 && !port[0]?.justMove){
        if(port[0].position === "first") port[0].position = 0;
        else if(port[0].position === "last") port[0].position = socialPost.length - 1;
        else return [];

        const firstPageEmbed = socialPost[port[0].position];
        const filterBy = [3258, 3262, 3278, 3260].includes(did) ? firstPageEmbed.className : attr;

        switch(true) {
          case filterBy.includes("twitter"):
            var parsedUrl, tweetId, firstPageTweet = socialPost[port[0].position];
    
            if(firstPageTweet.classList.contains("twitter-tweet-rendered")){
              firstPageTweet = firstPageTweet.querySelector("iframe");
              parsedUrl = new URL(firstPageTweet.src);
              tweetId = parsedUrl.searchParams.get("id");
            }
            else {
              firstPageTweet.querySelectorAll("a").forEach(el => {
                if(el.hasAttribute("href") && el.href.includes("/status/")) tweetId = el;
              });
              tweetId = tweetId.href.match(/status\/(\d+)/)[1];
            }
    
            tempArrPageTweets.push({ "Id": 1999999, "TwitterXCode": `https://twitframe.com/show?url=https://twitter.com/xxxxx/status/${tweetId}` });

            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";    
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo){
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              if(did === 3258){
                const parentSocial = unitAppendTo.closest(".component-social-twitter, .component-social-instagram");
                if (parentSocial) {
                  parentSocial.style.border = "0";
                  parentSocial.style.display = "block";
                  parentSocial.style.width = "100%";
                  parentSocial.style.minHeight = "auto";
                }

                if(unitAppendTo.parentNode.classList.contains("twitter-tweet-rendered")){
                  unitAppendTo.parentNode.style.display = "block";
                }

                const socialPost = unitAppendTo.parentNode.querySelector(".twitter-tweet-rendered");
                if(socialPost) socialPost.remove();
                unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
              }
              else {
                unitAppendTo.style.display = "block";
                unitAppendTo.className = "";

                try {
                  if(did === 3247){
                    const embedWrapper = unitAppendTo.closest(".wp-block-embed");
                    if (embedWrapper) {
                      unitAppendTo = embedWrapper;
                      unitAppendTo.innerHTML = "";
                    }
                  }
                } catch (error) {}

                if(unitAppendTo.innerHTML === '') unitAppendTo.append(tempUnit);
                else unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
              }
            } 
    
            firstPageTweet.remove();
            var blockquoteTwitter = document.querySelector(`blockquote.twitter-tweet a[href*='${tweetId}']`);
            if(blockquoteTwitter) blockquoteTwitter.parentNode.remove();
            break;
          case filterBy.includes("instagram"):
            var tweetId, firstPageTweet = socialPost[port[0].position];
    
            if(firstPageTweet.classList.contains("instagram-media-rendered") || firstPageTweet.tagName === "IFRAME"){
              tweetId = firstPageTweet.src.split('embed/')[0];
            }
            else {
              tweetId = firstPageTweet.querySelector('blockquote.instagram-media a');
              if(tweetId) tweetId = tweetId.getAttribute('href').split('?')[0];
              else return [];
            }

            tempArrPageTweets.push({ "Id": 1999999, "InstagramCode": tweetId });

            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";      
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo){
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              if(did === 3258){
                const parentSocial = unitAppendTo.closest(".component-social-instagram, .component-social-twitter");
                if (parentSocial) {
                  parentSocial.style.border = "0";
                  parentSocial.style.display = "block";
                  parentSocial.style.width = "100%";
                  parentSocial.style.minHeight = "auto";
                }

                const socialPost = unitAppendTo.parentNode.querySelector(".instagram-media-registered");
                if(socialPost) socialPost.remove();
                unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
              }
              else {
                unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
              }
            } 
    
            firstPageTweet.remove();
            var blockquoteTwitter = document.querySelector(`blockquote[data-instgrm-permalink^='${tweetId}']`);
            if(blockquoteTwitter) blockquoteTwitter.remove();
            break;
          case filterBy.includes("tiktok"):
            var tweetId, firstPageTweet = socialPost[port[0].position];
    
            if(firstPageTweet){
              tweetId = firstPageTweet.dataset.videoId;
            }
            else {
              return [];
            }

            tempArrPageTweets.push({ "Id": 1999999, "TikTokCode": `https://www.tiktok.com/embed/v2/${tweetId}` });

            var tempUnit = document.createElement("div"),
                containerElement = document.querySelector(`#${container}`),
                containerScript = document.querySelector(`.carambola`),
                unitAppendTo = firstPageTweet;
    
            tempUnit.id = "carambola-static-on-page";      
            if(containerElement) tempUnit.append(containerElement);
            if(containerScript) tempUnit.append(containerScript);
    
            if(unitAppendTo) { 
              Carambola.log("PageLoadEmbed");
              Carambola.changeChildElementWidth(unitAppendTo);
              unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
              unitAppendTo.parentNode.classList.remove("tiktok-wrap");
              unitAppendTo.parentNode.classList.remove("sl-tiktok-wrapper");
              unitAppendTo.parentNode.parentNode.classList.remove("tiktok-wrap");
              unitAppendTo.parentNode.parentNode.classList.remove("sl-tiktok-wrapper");
              unitAppendTo.parentNode.parentNode.parentNode.classList.remove("tiktok-wrap");
              unitAppendTo.parentNode.parentNode.parentNode.classList.remove("sl-tiktok-wrapper");
            }
  
            firstPageTweet.remove();
            break;            
        }

      } 
      else if(port[0]?.deleteIfSocialNotExist){
        var tempUnit = document.createElement("div"),
            containerElement = document.querySelector(`#${container}`),
            containerScript = document.querySelector(`.carambola`),
            insertTo = port[0].insertTo,
            insertToSelector = (insertTo) ? document.querySelector(insertTo) : null;

        tempUnit.id = "carambola-static-on-page";      
        if(containerElement) tempUnit.append(containerElement);
        if(containerScript) tempUnit.append(containerScript);

        if(insertToSelector){
          insertToSelector.append(tempUnit);
        }
        else {
          tempUnit.remove();
          var carambolaStyleExternal = document.querySelector(".carambola-external-style");
          if(carambolaStyleExternal) carambolaStyleExternal.remove();
          var carambolaStyle = document.querySelector(".carambola-style");
          if(carambolaStyle) carambolaStyle.remove();
        }
      }
      else if(port[0]?.justMove){
        var tempUnit = document.createElement("div"),
            containerElement = document.querySelector(`#${container}`),
            containerScript = document.querySelector(`.carambola`),
            unitAppendTo = document.querySelectorAll(port[0].insertAfter);
   
        if(unitAppendTo.length > 0){
          unitAppendTo = unitAppendTo[(port[0].position === "last") ? unitAppendTo.length - 1 : 0];
  
          tempUnit.id = "carambola-static-on-page";
          if(containerElement) tempUnit.append(containerElement);
          if(containerScript) tempUnit.append(containerScript);
  
          if(unitAppendTo) {  
            unitAppendTo.parentNode.insertBefore(tempUnit, unitAppendTo.nextSibling);
          }
        }    
      }
    } catch (error) {
      console.log(error);
    } finally {
      return tempArrPageTweets;
    }
  }

  Carambola.AbTestPageLoad = () => {
    const { layout, did, isMobile, wid, teleport, abtest } = Carambola.params;
    if(layout !== 201 && layout !== 202 && layout !== 211) return [];
    let tempArrPageTweets = "", port = Carambola.teleport.filter(el => el?.abtest && el.did === `11${did}` && el.wid === `${wid}` && (el.platform === "" || el.platform === null || el.platform === ((isMobile) ? "mobile" : "desktop")));
    if(port.length === 0) return [];
    if(port[0].position !== "first" && port[0].position !== "last") return [];
    if(typeof teleport !== "undefined" && teleport){
      try {
        const attr = port[0].attribute,socialPost = window.top.document.querySelectorAll(attr);
        
        if(socialPost.length > 0){
          switch(true) {
            case attr.includes("twitter"):
              tempArrPageTweets = "TwitterXCode";
              break;
            case attr.includes("instagram"):
              tempArrPageTweets = "InstagramCode";
              break;
            case attr.includes("tiktok"):
              tempArrPageTweets = "TikTokCode";
              break;  
            case attr.includes("bluesky"):
              tempArrPageTweets = "BlueskyCode";
              break;     
            case attr.includes("linkedin"):
              tempArrPageTweets = "LinkedinCode";
              break;    
            case attr.includes("facebook"):
              tempArrPageTweets = "FacebookCode";
              break;   
            case attr.includes("pinterest"):
              tempArrPageTweets = "PinterestCode";
              break;                                              
          }
        } 
      } catch (error) {
        console.log(error);
      } finally {
        if(abtest === 1 && tempArrPageTweets !== "") {
          Carambola.params.onePost = true;
        }
  
        return tempArrPageTweets;
      }
    } else return [];
  }

  Carambola.shuffle = (a) => {
    const { layout, teleport, did, wid, isMobile, abtest, unit } = Carambola.params;

    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }

    if(layout === 161 || layout === 162 || layout === 163){
      if(layout === 161 || layout === 163){
        let longTexts = a.filter(obj => obj.description.length >= 36);
        let shortTexts = a.filter(obj => obj.description.length < 36);
        a = longTexts.concat(shortTexts);
      }

      let mediaExist = a.filter(obj => obj.media !== "" && obj.media !== null);
      let mediaNotExist = a.filter(obj => obj.media === "" || obj.media === null);
      a = mediaExist.concat(mediaNotExist);
    }
    
    if(typeof teleport !== "undefined" && teleport){
      const firstTweet = Carambola.getFirstTweetFromPage();
      if(firstTweet.length > 0) {
        const port = Carambola.teleport.filter(el => el?.abtest && el.did === `11${did}` && el.wid === `${wid}` && (el.platform === "" || el.platform === null || el.platform === ((isMobile) ? "mobile" : "desktop")));
        
        if(abtest === 1 && port.length > 0) {
          a = firstTweet;
          Carambola.ads = [];
          Carambola.params.timer = 100000000;
          Carambola.params.onePost = true;
        } else {
          a = [...firstTweet, ...a];
        }
      }
      else if([3262, 3260, 3247, 3278].includes(did)){
        Carambola.params.lazyload = true;

        a = [{
          Id: 11111,
          Type: 18,
          Description: "FirstPost",
          InstagramCode: null,
          TikTokCode: null,
          TwitterXCode: null,
          YouTubeShortsCode: null,
          BlueskyCode: null,
          LinkedinCode: null,
          FacebookCode: null,
          PinterestCode: null
        }, ...a];

        let embedLogged = false;
        const observerEmbed = new MutationObserver((mutationsList) => {
          if (embedLogged) return false;
          else {
            Carambola.viewport = { unitViewport: false, unitViewportTime: null, currentOffset: 0, order: 1 };
            const firstTweet = Carambola.lazyLoadPost();

            if(firstTweet.length > 0) {
              const firstPost = firstTweet[0];
              Carambola.content.Items[0] = firstPost;
              Carambola.observerUnit();
              embedLogged = true;
              observerEmbed.disconnect();
              firstPostHtmlObj = unit.querySelector(".carambola-social-post");
              firstPostHtmlObj.innerHTML = '';
              Carambola.loadPost(firstPostHtmlObj);
            }
          }
        });
      
        observerEmbed.observe(window.top.document.body, { childList: true, subtree: true });
      }
    }

    return a;
  }

  Carambola.observerUnit = () => {
    const targetElement = window.top.document.getElementById("carambola-static-on-page"),
          observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          Carambola.log('load');
          observerInstance.unobserve(entry.target);
          observer.disconnect();
        }
      });
    });
  
    if (targetElement) {
      observer.observe(targetElement);
    }
  }

  Carambola.formatCount = (num) => {
    if(!num) return "0";
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
      const rounded = (num / 1000).toFixed(1);
      return rounded.replace(/\.0$/, '') + 'K';
    }
    return num.toString();
  }

  Carambola.fbPost = (post, embedContainer) => {
    const { cdn } = Carambola.params,
          embedDiv = Carambola.createHtmlObject('div', 'carambola-facebook-embed'),
          facebookLogo = Carambola.createHtmlObject('img', 'carambola-facebook-logo'),
          userImage = document.createElement('img'),
          userInfoDiv = Carambola.createHtmlObject('div', 'carambola-user-info'),
          userName = Carambola.createHtmlObject('div', 'carambola-user-name'),
          postDate = Carambola.createHtmlObject('div', 'carambola-post-date'),
          descriptionDiv = Carambola.createHtmlObject('div', 'carambola-description'),
          mediaDiv = Carambola.createHtmlObject('div', 'carambola-media'),
          engagementDiv = Carambola.createHtmlObject('div', 'carambola-engagement'),
          reactionsSpan = document.createElement('span'),
          likeIcon = document.createElement('img'),
          commentsSpan = document.createElement('span'),
          reshareSpan = document.createElement('span'),
          shareIcon = Carambola.createHtmlObject('img', 'carambola-share-icon'),
          commentsIcon = Carambola.createHtmlObject('img', 'carambola-comments-icon'),
          userHeaderDiv = Carambola.createHtmlObject('div', 'carambola-user-header');

    facebookLogo.src = `${cdn}/media/facebook.png`;
    facebookLogo.alt = 'Facebook';
    
    userImage.src = post.user_image;
    userImage.alt = post.user_display_name;
    userHeaderDiv.appendChild(userImage);

    userName.textContent = post.user_display_name;
    userInfoDiv.appendChild(userName);

    postDate.textContent = Carambola.formatDate(post.post_date);
    userInfoDiv.appendChild(postDate);
    userInfoDiv.appendChild(facebookLogo); 

    userHeaderDiv.appendChild(userInfoDiv);
    embedDiv.appendChild(userHeaderDiv);
 
    descriptionDiv.textContent = post.Description;
    embedDiv.appendChild(descriptionDiv);

    if (post.media || post.video) {
      if (post.video && post.video !== 0) {
          const videoElement = document.createElement('video');
          videoElement.controls = true;
          videoElement.src = post.video;
          videoElement.poster = post.media;
          videoElement.preload = "metadata";
          mediaDiv.appendChild(videoElement);
      } else if (post.media) {
          const imageElement = document.createElement('img');
          imageElement.src = post.media;
          imageElement.alt = 'Post media';
          mediaDiv.appendChild(imageElement);
      }
      embedDiv.appendChild(mediaDiv);
    }

    likeIcon.src = `${cdn}/media/like.png`;
    likeIcon.alt = 'Likes';
    reactionsSpan.appendChild(likeIcon);
    reactionsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.reactions)));
    engagementDiv.appendChild(reactionsSpan);

    commentsIcon.src = `${cdn}/media/comments.png`;
    commentsIcon.alt = 'Comments';
    commentsSpan.appendChild(commentsIcon);
    commentsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.comments)));
    engagementDiv.appendChild(commentsSpan);

    shareIcon.src = `${cdn}/media/share.png`;
    shareIcon.alt = 'Shares';
    reshareSpan.appendChild(shareIcon);
    reshareSpan.appendChild(document.createTextNode(Carambola.formatCount(post.reshare)));
    engagementDiv.appendChild(reshareSpan);

    embedDiv.appendChild(engagementDiv);
    embedContainer.appendChild(embedDiv);
  }

  Carambola.twitPost = (post, embedContainer) => {
    const { cdn } = Carambola.params,
          embedDiv = Carambola.createHtmlObject('div', 'carambola-facebook-embed'),
          logo = Carambola.createHtmlObject('img', 'carambola-facebook-logo'),
          userImage = document.createElement('img'),
          userInfoDiv = Carambola.createHtmlObject('div', 'carambola-user-info'),
          userName = Carambola.createHtmlObject('div', 'carambola-user-name'),
          postDate = Carambola.createHtmlObject('div', 'carambola-post-date'),
          descriptionDiv = Carambola.createHtmlObject('div', 'carambola-description'),
          mediaDiv = Carambola.createHtmlObject('div', 'carambola-media'),
          engagementDiv = Carambola.createHtmlObject('div', 'carambola-engagement'),
          reactionsSpan = document.createElement('span'),
          likeIcon = document.createElement('img'),
          commentsSpan = document.createElement('span'),
          reshareSpan = document.createElement('span'),
          shareIcon = Carambola.createHtmlObject('img', 'carambola-share-icon'),
          commentsIcon = Carambola.createHtmlObject('img', 'carambola-comments-icon'),
          userHeaderDiv = Carambola.createHtmlObject('div', 'carambola-user-header');

    logo.src = `${cdn}/media/x.png`;
    logo.alt = 'X';
    
    userImage.src = post.user_image;
    userImage.alt = post.user_display_name;
    userHeaderDiv.appendChild(userImage);

    userName.textContent = post.user_display_name;
    userInfoDiv.appendChild(userName);

    postDate.textContent = Carambola.formatDate(post.post_date);
    userInfoDiv.appendChild(postDate);
    userInfoDiv.appendChild(logo); 

    userHeaderDiv.appendChild(userInfoDiv);
    embedDiv.appendChild(userHeaderDiv);
 
    descriptionDiv.textContent = post.Description;
    embedDiv.appendChild(descriptionDiv);

    if (post.media || post.video) {
      if (post.video && post.video !== 0) {
          const videoElement = document.createElement('video');
          videoElement.controls = true;
          videoElement.src = post.video;
          videoElement.poster = post.media;
          videoElement.preload = "metadata";
          mediaDiv.appendChild(videoElement);
      } else if (post.media) {
          const imageElement = document.createElement('img');
          imageElement.src = post.media;
          imageElement.alt = 'Post media';
          mediaDiv.appendChild(imageElement);
      }
      embedDiv.appendChild(mediaDiv);
    }

    likeIcon.src = `${cdn}/media/tlike.png`;
    likeIcon.alt = 'Favorite';
    reactionsSpan.appendChild(likeIcon);
    reactionsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.favorite)));
    engagementDiv.appendChild(reactionsSpan);

    commentsIcon.src = `${cdn}/media/comments.png`;
    commentsIcon.alt = 'Reply';
    commentsSpan.appendChild(commentsIcon);
    commentsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.reply)));
    engagementDiv.appendChild(commentsSpan);

    shareIcon.src = `${cdn}/media/retweet.png`;
    shareIcon.alt = 'Retweet';
    reshareSpan.appendChild(shareIcon);
    reshareSpan.appendChild(document.createTextNode(Carambola.formatCount(post.retweet)));
    engagementDiv.appendChild(reshareSpan);

    embedDiv.appendChild(engagementDiv);
    embedContainer.appendChild(embedDiv);
  }

  Carambola.instaPost = (post, embedContainer) => {
    const { cdn } = Carambola.params,
          embedDiv = Carambola.createHtmlObject('div', 'carambola-facebook-embed'),
          logo = Carambola.createHtmlObject('img', 'carambola-facebook-logo'),
          userImage = document.createElement('img'),
          userInfoDiv = Carambola.createHtmlObject('div', 'carambola-user-info'),
          userName = Carambola.createHtmlObject('div', 'carambola-user-name'),
          postDate = Carambola.createHtmlObject('div', 'carambola-post-date'),
          descriptionDiv = Carambola.createHtmlObject('div', 'carambola-description'),
          mediaDiv = Carambola.createHtmlObject('div', 'carambola-media'),
          engagementDiv = Carambola.createHtmlObject('div', 'carambola-engagement'),
          reactionsSpan = document.createElement('span'),
          likeIcon = document.createElement('img'),
          commentsSpan = document.createElement('span'),
          reshareSpan = document.createElement('span'),
          shareIcon = Carambola.createHtmlObject('img', 'carambola-share-icon'),
          commentsIcon = Carambola.createHtmlObject('img', 'carambola-comments-icon'),
          userHeaderDiv = Carambola.createHtmlObject('div', 'carambola-user-header');

    logo.src = `${cdn}/media/instagram.png`;
    logo.alt = 'Instagram';
    
    userImage.src = post.user_image;
    userImage.alt = post.user_display_name;
    userHeaderDiv.appendChild(userImage);

    userName.textContent = post.user_display_name;
    userInfoDiv.appendChild(userName);

    postDate.textContent = Carambola.formatDate(post.post_date);
    userInfoDiv.appendChild(postDate);
    userInfoDiv.appendChild(logo); 

    userHeaderDiv.appendChild(userInfoDiv);
    embedDiv.appendChild(userHeaderDiv);
 
    descriptionDiv.textContent = post.Description;
    embedDiv.appendChild(descriptionDiv);

    if (post.media || post.video) {
      if (post.video && post.video !== 0) {
          const videoElement = document.createElement('video');
          videoElement.controls = true;
          videoElement.src = post.video;
          videoElement.poster = post.media;
          videoElement.preload = "metadata";
          mediaDiv.appendChild(videoElement);
      } else if (post.media) {
          const imageElement = document.createElement('img');
          imageElement.src = post.media;
          imageElement.alt = 'Post media';
          mediaDiv.appendChild(imageElement);
      }
      embedDiv.appendChild(mediaDiv);
    }

    likeIcon.src = `${cdn}/media/tlike.png`;
    likeIcon.alt = 'Like';
    reactionsSpan.appendChild(likeIcon);
    reactionsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.like)));
    engagementDiv.appendChild(reactionsSpan);

    commentsIcon.src = `${cdn}/media/comments.png`;
    commentsIcon.alt = 'Comments';
    commentsSpan.appendChild(commentsIcon);
    commentsSpan.appendChild(document.createTextNode(Carambola.formatCount(post.comment)));
    engagementDiv.appendChild(commentsSpan);

    shareIcon.src = `${cdn}/media/share.png`;
    shareIcon.alt = 'Share';
    reshareSpan.appendChild(shareIcon);
    reshareSpan.appendChild(document.createTextNode(Carambola.formatCount(post.share)));
    engagementDiv.appendChild(reshareSpan);

    embedDiv.appendChild(engagementDiv);
    embedContainer.appendChild(embedDiv);
  }

  Carambola.convertBlueskyURI = (atURI) => {
    return atURI.replace(/^at:\/\/(did:[^\/]+)\/app\.bsky\.feed\.post\/(.+)$/, "https://bsky.app/profile/$1/post/$2");
  }

  Carambola.detectObjSocialNetwork = (element) => {
    let srcLink, cssClass, clickUrl, platform, iframeSrc;

    if(element.hasOwnProperty("InstagramCode") && element.InstagramCode){
      cssClass = 'carambola-social-instagram';
      srcLink = (element.InstagramCode.slice(-1) === "/") ? `${element.InstagramCode}embed`: `${element.InstagramCode}/embed`;
      clickUrl = element.InstagramCode;
      platform = "Instagram";
    }

    if(element.hasOwnProperty("TikTokCode") && element.TikTokCode){
      cssClass = 'carambola-social-tiktok';
      srcLink = element.TikTokCode;
      clickUrl = element.TikTokCode;
      platform = "TikTok";
    }

    if(element.hasOwnProperty("BlueskyCode") && element.BlueskyCode){
      cssClass = 'carambola-social-bluesky';
      srcLink = element.BlueskyCode;
      clickUrl = Carambola.convertBlueskyURI(element.BlueskyCode);
      platform = "Bluesky";
    }

    if(element.hasOwnProperty("YouTubeShortsCode") && element.YouTubeShortsCode){
      cssClass = 'carambola-social-youtube-shorts';
      srcLink = element.YouTubeShortsCode;
      clickUrl = element.YouTubeShortsCode;
      platform = "YouTubeShorts";
    }

    if(element.hasOwnProperty("LinkedinCode") && element.LinkedinCode){
      cssClass = 'carambola-social-linkedin';
      srcLink = element.LinkedinCode;
      clickUrl = element.LinkedinCode.replace("embed/","");
      platform = "Linkedin";
    }

    if(element.hasOwnProperty("FacebookCode") && element.FacebookCode){
      cssClass = 'carambola-social-facebook';
      srcLink = element.FacebookCode;
      clickUrl = element.FacebookCode;
      platform = "Facebook";
    }

    if(element.hasOwnProperty("InstagramTextCode") && element.InstagramTextCode){
      cssClass = 'carambola-social-facebook';
      srcLink = `https://www.instagram.com/p/${element.InstagramTextCode}`;
      clickUrl = `https://www.instagram.com/p/${element.InstagramTextCode}`;
      platform = "InstagramText";
    }

    if(element.hasOwnProperty("TwitterTextCode") && element.TwitterTextCode){
      cssClass = 'carambola-social-facebook';
      srcLink = `https://twitter.com/xxxx/status/${element.TwitterTextCode}`;
      clickUrl = `https://twitter.com/xxxx/status/${element.TwitterTextCode}`;
      platform = "TwitterText";
    }

    if(element.hasOwnProperty("PinterestCode") && element.PinterestCode){
      cssClass = 'carambola-social-pinterest';
      srcLink = element.PinterestCode;
      clickUrl = element.PinterestCode;
      platform = "Pinterest";
    }

    if(element.hasOwnProperty("TwitterXCode") && element.TwitterXCode){
      const tweet_id = element.TwitterXCode.match(/status\/(\d+)/);
      cssClass = 'carambola-social-x';
      srcLink = element.TwitterXCode;
      iframeSrc = `https://platform.twitter.com/embed/Tweet.html?id=${tweet_id[1]}`;
      clickUrl = `https://twitter.com/xxxx/status/${tweet_id[1]}`;
      platform = "Twitter";
    }

    if(Carambola.params.layout === 161 || Carambola.params.layout === 163) {
      cssClass = 'carambola-social-x';
      platform = "Twitter";
      clickUrl = `https://twitter.com/${element.user_display_name}/status/${element.tweet_id}`;
      srcLink = `https://platform.twitter.com/embed/Tweet.html?id=${element.tweet_id}`;
    }  
    
    return {
      css: cssClass,
      src: srcLink,
      click: clickUrl,
      iframeSrc,
      platform
    }
  }

  Carambola.postScreenPosition = (post = null) => {
    const w = (post === "Pinterest") ? 1040 : 800, h = 640;
    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.screen.width;
    const height = window.screen.height;

    const left = (width - w) / 2 + dualScreenLeft;
    const top = (height - h) / 2 + dualScreenTop;

    return { w, h, top, left };
  }

  Carambola.nextScrollCheckTimeOut = () => {
    let iteration = Carambola.viewport.order,
        value = 30;

    if (iteration <= 2) value = 5;
    else if (iteration <= 4) value = 10;
    else if (iteration <= 6) value = 20;
    return value;
  }

  Carambola.debounce = (func) => {
    let timerId;
  
    return function(...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, Carambola.nextScrollCheckTimeOut() * 1000);
    };
  }

  Carambola.setScroll = () => {
    if(Carambola.viewport.currentOffset !== window.top.scrollY){
      Carambola.viewport.currentOffset = window.top.scrollY;
    }
  }

  Carambola.debouncedInputHandler = Carambola.debounce(Carambola.setScroll);

  Carambola.parseResponse = (json, obj = Carambola.params.unit) => {
    const { did, layout, isMobile, multi_ad, unit } = Carambola.params;

    try {        
      if((`11${did}` === "113255" || `11${did}` === "113257" || `11${did}` === "113256") && isMobile && window.frameElement){
        window.frameElement.width = 320;
        window.frameElement.height = 400;
      }
    } catch (error) {}

    Carambola.checkIfInViewport();
    window.top.addEventListener('scroll', () => { Carambola.checkIfInViewport(); }, { capture: true, passive: true });
    window.top.addEventListener('scroll', Carambola.debouncedInputHandler);
    window.top.addEventListener("beforeunload", () => {
      if(Carambola.viewport.unitViewport) Carambola.log('CalcViewportTime');

      let dtSeconds = Carambola.round((new Date().getTime() - Carambola.params.dwellTime) / 1000, 2),
          dtEmbedSeconds = Carambola.round((new Date().getTime() - Carambola.params.dwellTimeEmbed) / 1000, 2);

      Carambola.params.dwellTime = 0;
      Carambola.fetchEvents("Unit", "DwellTime", dtSeconds);

      if(Carambola.params.dwellTimeEmbed > 0) {
        Carambola.fetchEvents("Unit", "DwellTimeEmbed", dtEmbedSeconds);
        Carambola.params.dwellTimeEmbed = 0;
      }
    });

    window.addEventListener('load', function () {
      try {
        if (performance && performance.getEntriesByType("navigation")[0].type === 'reload') {
            if(window.location !== window.top.location) Carambola.log('WidgetRefresh');
        }
      } catch (error) {}
    });

    if(layout === 162 || layout === 201 || layout === 211 || layout === 202){
      const wrap = unit.querySelector('.carambola-wrap');

      wrap.addEventListener('mouseenter', (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(Carambola.params.cbolaActiveElementTimeout);
      });

      wrap.addEventListener('mouseleave', (e) => {
        e.preventDefault();
        e.stopPropagation();
        Carambola.scrollAnimation(unit.querySelector(".carambola-social-wrapper"));
      });
    }

    if(json && json.length > 0) {
      switch(layout) {
        case 201:   
        case 202:  
        case 211:
        case 161:  
        case 163:
          let postCount = 0;
          json.forEach((element, index) => { 
            const { css } = Carambola.detectObjSocialNetwork(element),
                  socialWrap211 = Carambola.createHtmlObject('div', "carambola-element carambola-social-post");
                  
            socialWrap211.setAttribute("rel", index);

            if(index === 0) {
              const scrollWrap = Carambola.createHtmlObject('div', 'carambola-scroll-wrapper');
              scrollWrap.append(Carambola.scrollArrow());
              socialWrap211.classList.add('carambola-element-active');
              socialWrap211.append(scrollWrap);
            }   

            if([211, 202, 201].includes(layout) && postCount < 3) {
              Carambola.loadPost(socialWrap211);
              postCount++;
            }

            socialWrap211.classList.add(css);
            if(layout === 161 || layout === 163) {
              socialWrap211.classList.add("carambola-loaded");
              Carambola.tweets160(element, index, socialWrap211);
            }
            socialWrap211.dataset.interval = Carambola.params.timer * 1000;
            obj.querySelector(".carambola-social-content").append(socialWrap211);
          });          

          Carambola.loadMoreAds(0);
          Carambola.userScroll();
          Carambola.scrollAnimation(Carambola.params.unit.querySelector(".carambola-social-wrapper"));

          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") Carambola.scrollAnimation(obj.querySelector(".carambola-social-wrapper"));
          });

          if(did === 2565 && layout === 202 && multi_ad){
            setTimeout(() => {
              Carambola.loadThreeAds(unit.querySelector(".carambola-social-post"));
            }, 100);
          }

          break;  
        case 162:  
          var firstElementAd = Carambola.inContentAdsList();
          json.forEach((element, index) => {
            if(index === 0 && !firstElementAd[1]) {
              let socialWrap = Carambola.createHtmlObject("div", "carambola-element carambola-social-post carambola-active"); 
              socialWrap.dataset.interval = Carambola.params.timer * 1000;
              const twitt = Carambola.tweets160(element, index, socialWrap);
              obj.querySelector(".carambola-social-content").append(twitt);
            } else {
              let socialWrap = Carambola.createHtmlObject("div", "carambola-element carambola-social-post"); 
              socialWrap.dataset.interval = Carambola.params.timer * 1000;
              socialWrap.setAttribute("rel", index);
              const twitt = Carambola.tweets160(element, index, socialWrap);
              obj.querySelector(".carambola-social-content").append(twitt);
            }
          });  
          
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") Carambola.setTimeoutNext();
          });
          Carambola.loadMoreAds162();
          Carambola.userScroll162();
          break;         
        case 160: 
        case 152: 
          var firstElementAd = Carambola.inContentAdsList();
          Carambola.params.contentCount++;
          json.forEach((element, index) => {
            if(index === 0 && !firstElementAd[1]) {
              let socialWrap = Carambola.createHtmlObject("div", "carambola-element carambola-social-post carambola-loaded carambola-active"); 
              socialWrap.dataset.interval = Carambola.params.timer * 1000;
              const twitt = (layout !== 152) ? Carambola.tweets160(element, index, socialWrap) : Carambola.content152(element, index, socialWrap);
              obj.querySelector(".carambola-tweets-list").append(twitt);
            } else {
              let socialWrap = Carambola.createHtmlObject("div", "carambola-element carambola-social-post"); 
              socialWrap.dataset.interval = Carambola.params.timer * 1000;
              socialWrap.setAttribute("rel", index);
              obj.querySelector(".carambola-tweets-list").append(socialWrap);
            }
          });  

          if(layout === 160 || layout === 152){
            Carambola.loadMoreAds(0);
            if(firstElementAd[1]){
              obj.querySelector(".carambola-social-ad.carambola-incontent-1").classList.add("carambola-active");
            }
          }

          if((layout === 160 || layout === 152) && firstElementAd[1]){
            Carambola.loadFirstAd();
          }
          Carambola.setTimeoutNext();
          
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") Carambola.setTimeoutNext();
          });

          if(did === 2986 && layout === 152 && multi_ad){
            setTimeout(() => {
              Carambola.loadThreeAds(unit.querySelector(".carambola-social-post"));
            }, 100);
          }
          break;            
      }
    }
  }

  Carambola.uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  Carambola.scrollAnimation = (wrap) => { 
    if(Carambola.detectIfInViewport(Carambola.params.unit)) Carambola.scrollNext(wrap); 
    wrap.addEventListener("scroll", () => {Carambola.unitScrollStop(wrap);}, false);
  }

  Carambola.unitScrollStop = (wrap) => {
    let scrollWrap = Carambola.params.unit.querySelector('.carambola-scroll-wrapper');
    if(scrollWrap !== null) scrollWrap.remove();
    
    clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
    Carambola.params.cbolaWheelEventEndTimeout = setTimeout(() => {
        Carambola.scrollNext(wrap);
    }, 100);
  }

  Carambola.oneActive = (wrap) => {
    const { layout, unit } = Carambola.params;

    if(layout === 163){
      if(unit.querySelector(".carambola-element-active")) {
        if(unit.querySelector(".carambola-element-active").classList.contains("carambola-social-ad")) {
          unit.querySelector(".carambola-logo").classList.add("carambola-hide");
          unit.querySelector(".carambola-social-wrapper").classList.add("carambola-hide-scroll");
        }
        else {
          unit.querySelector(".carambola-logo").classList.remove("carambola-hide");
          unit.querySelector(".carambola-social-wrapper").classList.remove("carambola-hide-scroll");
        }
      }
    }
  }

  Carambola.scrollNext = (wrap) => {
    const { teleport } = Carambola.params;
    try {
      Carambola.oneActive(wrap);
      let activeElement = wrap.querySelector('.carambola-element-active');
      if(!activeElement.dataset.height) activeElement.dataset.height = activeElement.offsetHeight;
      clearTimeout(Carambola.params.cbolaActiveElementTimeout);
      if(!activeElement || !Carambola.detectIfInViewport(Carambola.params.unit) || wrap.classList.contains("carambola-hover")) return false;
      const activeRel = activeElement.dataset.interval;
      Carambola.params.cbolaActiveElementTimeout = setTimeout(()=> {
        const active = wrap.querySelector('.carambola-element.carambola-element-active'),
              list = [...wrap.querySelectorAll('.carambola-element')],
              indexOfActive = list.indexOf(active);

        let nextElement = wrap.querySelectorAll('.carambola-element')[indexOfActive + 1];
        if(!nextElement) {
          if(teleport) return false;
          if(Carambola.content.hasOwnProperty("Items")) {
            document.querySelector(`#${Carambola.params.container}`).innerHTML = '';
            let layoutStyleExternal = document.querySelector(`.carambola-external-style-layout-${Carambola.params.layout}`);
            if(layoutStyleExternal) layoutStyleExternal.remove();            
            let layoutStyle = document.querySelector(`.carambola-style-layout-${Carambola.params.layout}`);
            if(layoutStyle) layoutStyle.remove();
            Carambola.renderStyle();
            Carambola.renderUnit();
            Carambola.renderAds();
            Carambola.parseResponse(Carambola.content.Items);
          }
        }

        if(nextElement && Carambola.detectIfInViewport(Carambola.params.unit) && document.visibilityState === 'visible'){        
          if(active) active.classList.remove('carambola-element-active');
          if(nextElement) nextElement.classList.add('carambola-element-active');
          Carambola.scrollToPosition(wrap, nextElement);
          Carambola.scrollNext(wrap);
        }
      }, activeRel);
    } catch (error) {}
  }

  Carambola.scrollToPosition = (parent, child) => {
    var parentRect = parent.getBoundingClientRect(),
        childRect = child.getBoundingClientRect(),
        parentViewableArea = { height: parent.clientHeight, width: parent.clientWidth },
        isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

    const scrollToPlace = (Carambola.params.layout === 162) ? child.offsetTop - 5 : child.offsetTop;
    parent.scrollTop = scrollToPlace;
  }

  Carambola.getItemId = (item) => {
    const { layout } = Carambola.params;
    return (layout === 160 || layout === 162 || layout === 161 || layout === 163) ? item.tweet_id : item.Id;
  }

  Carambola.log = (type, platform = null, eventId = null) => {
    const { pid, did, wid, layout, isMobile, pageViewId, UserId = 0, clientVersion, clicked, multi_ad, unit } = Carambola.params,
          { PageId = 1000 , Category = 1000 } = Carambola.content,
          logObj = {
            'pageid': PageId,
            'pubid': pid,
            'did': `11${did}`,
            'wid': wid,
            'layouttype': layout,
            'categoryid': Category,
          };

    let analyticsData = {
      ClientVersion: clientVersion,
      PageViewId: pageViewId,
      PageId: PageId,
      UserId: UserId,
      PublisherId: pid,
      Second: Carambola.round((performance.now() - Carambola.params.second) / 1000, 2),
      categoryId: Category,
      domainId: did,
      IsMobile: isMobile,
      IsTablet: false,
      isPortrait: false,
      AbTestId: 1,
      WidgetId: wid
    };

    switch (type) {
      case "PageLoad":
        Carambola.fetchEvents("Unit", "PageLoad");
        Carambola.params.dwellTime = Date.now();

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            let dtSeconds = Carambola.round((new Date().getTime() - Carambola.params.dwellTime) / 1000, 2);
            if(Carambola.params.dwellTime > 0) Carambola.fetchEvents("Unit", "DwellTime", dtSeconds);
          } else {
            Carambola.params.dwellTime = Date.now();
          }
        });
        break;      
      case "LogoClick":
        Carambola.fetchEvents("UserAction", "LogoClick");
        break;    
      case "Skip":
        Carambola.fetchEvents("UserAction", "Skip");
        break;      
      case "Yes":
        Carambola.fetchEvents("UserAction", "Yes");
        break;     
      case "No":
        Carambola.fetchEvents("UserAction", "No");
        break;    
      case "WidgetRefresh":
        Carambola.fetchEvents("Unit", "WidgetRefresh");
        break;   
      case "ClickAd":
        Carambola.fetchEvents("UserAction", "ClickAd");
        break;      
      case "ClickNext":
        Carambola.fetchEvents("UserAction", "ClickNext");
        break;      
      case "ClickPrevious":
        Carambola.fetchEvents("UserAction", "ClickPrevious");
        break;    
      case "X":
        Carambola.fetchEvents("UserAction", "X");
        break;          
      case "Swipe":
        Carambola.fetchEvents("UserAction", "Swipe");
        break;                        
      case "load":
        Carambola.params.widgetLoad = true;
        Carambola.fetchEvents("Unit", "WidgetLoad");
        
        if(did !== 2565 && did !== 2986 && multi_ad){
          setTimeout(() => {
            if([211, 201, 202, 152].includes(layout)) {
              Carambola.loadThreeAds(unit.querySelector(".carambola-social-post"));
            }
          }, 100);
        }

        Carambola.renderAds();
        break;
      case "PageLoadEmbed":
        Carambola.fetchEvents("Unit", "PageLoadEmbed");

        Carambola.params.dwellTimeEmbed = Date.now();

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            let dtEmbedSeconds = Carambola.round((new Date().getTime() - Carambola.params.dwellTimeEmbed) / 1000, 2);
            if(Carambola.params.dwellTimeEmbed > 0) Carambola.fetchEvents("Unit", "DwellTimeEmbed", dtEmbedSeconds);
          } else {
            Carambola.params.dwellTimeEmbed = Date.now();
          }
        });
        break;        
      case "click":
        if(clicked) return false;
        if(platform) logObj.platform = platform; 
        Carambola.fetchEvents("UserAction", "ClickPost", platform);      
        Carambola.params.clicked = true;
        break;
      case "scroll":
        Carambola.fetchEvents("UserAction", "Scroll");
        break;     
      case "hover":
        Carambola.fetchEvents("UserAction", "Hover");
        break; 
      case "CalcViewportTime":
        analyticsData.EventId = 151;
        analyticsData.Second = Carambola.round((new Date().getTime() - Carambola.viewport.unitViewportTime) / 1000, 2);
        Carambola.fetchEvents("Unit", "ViewTime", analyticsData.Second);
        logObj.second = analyticsData.Second;

        if(Carambola.params.contentCount > 0) Carambola.fetchEvents("Unit", "ContentCount");
        if(Carambola.params.adCount > 0) Carambola.fetchEvents("Unit", "AdCount");
        if(Carambola.params.totalHover > 0) Carambola.fetchEvents("Unit", "HoverTime");

        Carambola.params.contentCount = 0;
        Carambola.params.adCount = 0;
        Carambola.params.totalHover = 0;
        break;     
      case "SetScroll":
        analyticsData.Order = Carambola.viewport.order;
        analyticsData.PixelsFromTop = Carambola.viewport.currentOffset;
        Carambola.fetchEvents("UserAction", "Scroll");
        Carambola.viewport.order++;
        break;  
      case "FollowUs":
        Carambola.fetchEvents("UserAction", "FollowUs");
        break;  
      case "AdDelivered":
        Carambola.fetchEvents("Unit", "AdDelivered");
        break;                           
    }
  }

  Carambola.getBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf("edge") > -1 || userAgent.indexOf("edg/") > -1 || userAgent.indexOf("edga/") > -1) {
      return "Edge";
    } else if (userAgent.indexOf("samsungbrowser") > -1) {
      return "Samsung Browser";
    } else if ((userAgent.indexOf("chrome") > -1 || userAgent.indexOf("crios") > -1) && userAgent.indexOf("edg/") === -1) {
      return "Chrome";
    } else if (userAgent.indexOf("firefox") > -1) {
      return "Firefox";
    } else if (userAgent.indexOf("opera") > -1 || userAgent.indexOf("opr") > -1) {
      return "Opera";
    } else if (userAgent.indexOf("safari") > -1 && userAgent.indexOf("chrome") === -1) {
      return "Safari";
    } else {
      return "Other";
    }
  }

  Carambola.detectOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('windows') !== -1) {
      return 'Windows';
    }  else if (/iphone|ipad|ipod/i.test(userAgent)) { 
      return 'iOS';
    } else if (userAgent.indexOf('mac os') !== -1) {
      return 'macOS';
    } else if (userAgent.indexOf('android') !== -1) { 
      return 'Android';
    } else if (userAgent.indexOf('linux') !== -1) {
      return 'Linux';
    } else {
      return 'Other';
    }
  }

  Carambola.fetchEvents = (eventType, eventName, info = null) => {
    const { pid, did, wid, layout, isMobile, clientVersion, uuid, adCount, contentCount, totalHover, onePost, lazyload, socialFollowAbtest, outOfFrameShow } = Carambola.params,
          data = {
            Pkey: pid,
            DID: did,
            WID: wid,
            UID: uuid,
            Layout: layout,
            Platform: isMobile ? "mobile" : "desktop",
            URL: window.top.location.href,
            ClientVersion: clientVersion,
            GAM: true,
            Version: "a",
            Event: eventName,
            Action: eventType,
            Seconds: 0,
            OS: Carambola.detectOS(),
            BrT: Carambola.getBrowser(),
            Count: 0
          };

    if(window.top.location.host === "localhost:3000") {
      console.log(`Carambola.fetchEvents: ${eventName}`);
      return false;
    }

    if(onePost) data.WID = 1000;
    if(socialFollowAbtest === 1) data.WID = 2000;
    if(!outOfFrameShow) data.WID = 3000;
    if(eventName === "ClickPost" && info) data.Social = info;  
    if(eventName === "ViewTime" && info) data.Seconds = info; 
    if(eventName === "DwellTime" && info) data.Seconds = info; 
    if(eventName === "DwellTimeEmbed" && lazyload) return false; 
    if(eventName === "DwellTimeEmbed" && info) data.Seconds = info; 
    if(eventName === "ContentCount") data.Count = contentCount;  
    if(eventName === "AdCount") data.Count = adCount; 
    if(eventName === "HoverTime") data.Seconds = totalHover / 1000;

    const queryString = new URLSearchParams(data).toString(),
          url = `https://event.carambo.la/${eventType}/${eventName}?${queryString}`;

    fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      mode: 'no-cors'
    }); 
  }

  Carambola.checkIfInViewport = function() {
    const { unit, layout, teleport, did, wid, container } = Carambola.params; 

    if(Carambola.detectIfInViewport(unit)) {
      unit.querySelector(".carambola-wrap").classList.add('carambola-in-viewport');
      if(!Carambola.viewport.unitViewport){
        Carambola.viewport.unitViewport = true;
        try{
          if (!unit.hasAttribute("in_viewport")) {
            unit.setAttribute("in_viewport","true");
            if(did === 3258){
              if (window.top.document.getElementById("carambola-static-on-page")) {
                Carambola.log('load');
              }
              else {
                Carambola.log = () => {} 
                const containerElement = document.querySelector(`#${container}`),
                      containerScript = document.querySelector(`.carambola`);

                if(containerElement && containerScript){
                  containerElement.remove();
                  containerScript.remove();
                }      
                return false;
              }
            }
            else if(Carambola.params.lazyload) { }
            else { 
              Carambola.log('load');
              
              if(layout === 152){
                Carambola.outOfFrameLoad();
              }
            }
          }

         
        }
        catch(err){console.log(err);}
        Carambola.viewport.unitViewportTime = new Date().getTime();

        if(unit.querySelector(".carambola-ad-iframe")) return false;

        if(layout === 211 || layout === 202 || layout === 201 || layout === 162 || layout === 161 || layout === 163) {
          setTimeout(() => {
            Carambola.scrollNext(unit.querySelector(".carambola-social-wrapper"));
          }, 300);
        }
      }
      else {
        if(layout === 160 || layout === 152) {
          if(unit.querySelector(".carambola-ad-iframe")) return false;
          Carambola.setTimeoutNext();
        }
      }

      
    } 
    else {
      if(Carambola.viewport.unitViewport) {
        Carambola.viewport.unitViewport = false;
        Carambola.log('CalcViewportTime');
        clearTimeout(Carambola.params.carouselTimeout);
        unit.classList.remove('carambola-in-viewport');
      }
    }
  }

  Carambola.outOfFrameLoad = () => {
    const { unit } = Carambola.params;
    var outAdArr = Carambola.ads.filter(ad => ad.adType === "outOfFrame");

    if(outAdArr.length > 0){
      const adWrap = Carambola.createHtmlObject("div", "carambola-out-of-frame"),
            wrap = unit.querySelector(".carambola-wrap"), 
            iframeClass = `carambola-out-of-frame-ad-${Carambola.uniqueId()}`,
            currentAd = outAdArr[0],
            adSizeArr = currentAd.size.split("x"),
            adWidth = parseInt(adSizeArr[0]),
            adHeight = parseInt(adSizeArr[1]);

      wrap.style.height = "300px";
      wrap.append(adWrap);   
    
      Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass);

      if(!adWrap.classList.contains('carambola-check-if-ad-exist')){
        adWrap.classList.add('carambola-check-if-ad-exist');
        setTimeout(() => {
          if(adWrap.querySelector("iframe")) {
            Carambola.log("AdDelivered");
            adWrap.classList.add('carambola-ad-exist');
          }
        }, 2000);
      }

      if(currentAd.refresh) {
        const adIframe = adWrap.querySelectorAll(`.${iframeClass}`);
        if(adIframe && adIframe.length > 0) {
          setInterval(()=>{ 
            adWrap.replaceChildren(); 
            Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass, true);
          }, currentAd.refresh * 1000);
        }
      }
    }
  }

  Carambola.round = (number, precision = 0) => {
    const multiplier = Math.pow(10, precision);
    return Math.round(number * multiplier) / multiplier;
  }

  Carambola.generatePageViewId = () => {
    var randomNumber = Math.floor((Math.random() * 90000) + 10000);
    var currentdate = new Date();
    var currentTime = {
        getDate: currentdate.getDate(),
        getMonth: currentdate.getMonth(),
        getFullYear: currentdate.getFullYear(),
        getHours: currentdate.getHours(),
        getMinutes: currentdate.getMinutes(),
        getSeconds: currentdate.getSeconds(),
        getMilliseconds: currentdate.getMilliseconds()
      };
    return ((currentTime.getDate <= 9) ? '0' + (currentTime.getDate) : (currentTime.getDate)) + '' +
      (currentTime.getMonth + 1 <= 9 ? '0' + (currentTime.getMonth + 1) : (currentTime.getMonth + 1)) + '' +
      currentTime.getFullYear % 100 + '' +
      (currentTime.getHours <= 9 ? '0' + currentTime.getHours : currentTime.getHours) + '' +
      (currentTime.getMinutes <= 9 ? '0' + currentTime.getMinutes : currentTime.getMinutes) + '' +
      (currentTime.getSeconds <= 9 ? '0' + currentTime.getSeconds : currentTime.getSeconds) + '' +
      (currentTime.getMilliseconds % 100 <= 9 ? '0' + (currentTime.getMilliseconds % 100) : (currentTime.getMilliseconds % 100)) + '' +
      (randomNumber);
  }

  Carambola.createHtmlObject = (type, className) => {
    const htmlObj = document.createElement(type);
    htmlObj.className = className;
    return htmlObj;
  }

  Carambola.makeLinksClickable = (text) =>{
    const { w, h, top, left } = Carambola.postScreenPosition();
    const urlRegex = /((https?|ftp|mailto):\/\/[^\s]+)/g;
    const newText = text.replace(urlRegex, (match) => {
      return `<a href="javascript: window.top.open('${match}', 'Social Media', 'scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}');">${match}</a>`;
    });
    return newText;
  }

  Carambola.formatPostDate = (postDate) => {
    const date = new Date(postDate);

    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    const time = date.toLocaleTimeString('en-US', options);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    return `${time} · ${month} ${day}, ${year}`;
  }

  Carambola.tweets160 = (tweet, index, obj) => {
    const { layout, unit, isMobile } = Carambola.params,
          { w, h, top, left } = Carambola.postScreenPosition();
    const twitterItem = Carambola.createHtmlObject('div', 'carambola-tweet-item');
    const twitterUserWrap = Carambola.createHtmlObject('div', 'carambola-tweet-user');
    const twitterUserImage = Carambola.createHtmlObject('img', 'carambola-tweet-user-image');
    twitterUserImage.src = tweet.user_image;

    const twitterUserDetails = Carambola.createHtmlObject('div', 'carambola-tweet-user-details');
    const twitterUserFullName = Carambola.createHtmlObject('div', 'carambola-tweet-user-fullname');
    twitterUserFullName.textContent = tweet.user_full_name;

    const twitterUserDisplayName = Carambola.createHtmlObject('div', 'carambola-tweet-user-displayname');
    twitterUserDisplayName.textContent = `@${tweet.user_display_name}`;
    
    const twitterDescription = Carambola.createHtmlObject('div', 'carambola-tweet-description');
    twitterDescription.innerHTML = Carambola.makeLinksClickable(tweet.description);
    
    twitterUserDetails.append(twitterUserFullName);
    twitterUserDetails.append(twitterUserDisplayName);

    if(layout === 162 || layout === 161 || layout === 163){
      if(layout === 162){
        const twitterLink = Carambola.createHtmlObject('a', 'carambola-tweet-link');
        const rightPlaceholder = Carambola.createHtmlObject('div', 'carambola-right-placeholder');
        twitterLink.href = `javascript: window.top.open('https://x.com/${tweet.user_display_name}/status/${tweet.tweet_id}', 'Social Media', 'scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}');`;
        twitterLink.textContent = `https://x.com/${tweet.user_display_name}/status/${tweet.tweet_id}`;

        if(tweet.media){
          const twitterImage = Carambola.createHtmlObject('img', 'carambola-tweet-image');
          twitterImage.src = tweet.media;
          twitterImage.onerror = function() {
            this.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/ckouYQAAAAASUVORK5CYII=';
          };

          twitterImage.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.top.open(`https://x.com/${tweet.user_display_name}/status/${tweet.tweet_id}` , 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
            Carambola.log('click', "Twitter", 30);
          });

          rightPlaceholder.append(twitterImage);

          if(tweet.video) {
            const twitterPlay = Carambola.createHtmlObject('div', 'carambola-play'),
                  twitterPlayDiv = document.createElement('div'),
                  g = Carambola.createHtmlObject('div', 'carambola-play-button');

            twitterPlayDiv.append(g);
            twitterPlay.append(twitterPlayDiv);
            rightPlaceholder.append(twitterPlay);
          }
        }

        twitterDescription.append(twitterLink);
        obj.append(rightPlaceholder);
      }
      else if((layout === 161 || layout === 163) && tweet.media){
        const twitterImageWrap = Carambola.createHtmlObject('div', 'carambola-tweet-wrap-image');
        const twitterImage = Carambola.createHtmlObject('img', 'carambola-tweet-image');
        twitterImage.src = tweet.media;
        twitterImageWrap.append(twitterImage);
        twitterDescription.append(twitterImageWrap);

        if(tweet.video) {
          const twitterPlay = Carambola.createHtmlObject('div', 'carambola-play'),
                twitterPlayDiv = document.createElement('div'),
                g = Carambola.createHtmlObject('div', 'carambola-play-button');

          twitterPlayDiv.append(g);
          twitterPlay.append(twitterPlayDiv);
          twitterImageWrap.append(twitterPlay);
        }
      }
      else if((layout === 161 || layout === 163) && !tweet.media && tweet.description.length < 36){
        const twitterMoreContent = Carambola.createHtmlObject('div', 'carambola-tweet-more-content');
        twitterMoreContent.textContent = ">>> more content";
        twitterDescription.append(twitterMoreContent);
      }

      const twitterFollow = Carambola.createHtmlObject('span', 'carambola-tweet-follow');
      twitterFollow.textContent = "Follow"
      twitterUserDetails.append(" • ");
      twitterUserDetails.append(twitterFollow);

      var x = Carambola.createHtmlObject('img', 'carambola-logo-x');
      x.src = (layout === 161 || layout === 163) ? `${Carambola.params.cdn}/media/x.png` : `${Carambola.params.cdn}/media/x2.svg`;
      twitterItem.append(x); 
    }
    
    twitterUserWrap.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if(layout === 160) Carambola.unit160Actions('follow');
      if(layout === 162) Carambola.unitGoToInPopUp(`https://twitter.com/intent/follow?screen_name=${tweet.user_display_name}`);
      Carambola.log('click', "Twitter", 31);
    });

    twitterUserWrap.append(twitterUserImage);
    twitterUserWrap.append(twitterUserDetails);
    twitterItem.append(twitterUserWrap); 
    twitterItem.append(twitterDescription);

    if(layout === 161 || layout === 162 || layout === 163){
      const twitterFooter = Carambola.createHtmlObject('div', 'carambola-tweet-footer'),
      twitterActions = Carambola.createHtmlObject('div', 'carambola-tweet-actions'),
      twitterLike = Carambola.createHtmlObject('div', 'carambola-tweet-like'),
      twitterLikeCount = document.createElement('span'),
      twitterMessageCount = document.createElement('span'),
      twitterSvgWrap = Carambola.createHtmlObject('div', 'carambola-tweet-svg-wrap'),
      twitterLikeImage = document.createElement('img'),
      twitterMessage = Carambola.createHtmlObject('div', 'carambola-tweet-message'),
      twitterSvgWrap2 = Carambola.createHtmlObject('div', 'carambola-tweet-svg-wrap'),
      twitterSvgWrap3 = Carambola.createHtmlObject('div', 'carambola-tweet-svg-wrap'),
      twitterMessageImage = document.createElement('img'),
      twitterShareImage = document.createElement('img'),
      twitterReply = Carambola.createHtmlObject('a', 'carambola-tweet-reply'),
      twitterDate = Carambola.createHtmlObject('div', 'carambola-tweet-date'),
      twitterShare = Carambola.createHtmlObject('div', 'carambola-tweet-share');

      if(layout === 161 || layout === 163) {
        twitterShare.textContent = 'Share this Tweet';   
      }
      twitterReply.textContent = 'Tweet your reply';   
      twitterLikeCount.textContent = tweet.favs;
      twitterMessageCount.textContent = tweet.retweets;
      twitterLikeImage.src = `${Carambola.params.cdn}/media/heart-162.svg`;
      twitterMessageImage.src = `${Carambola.params.cdn}/media/message-162.svg`;
      twitterShareImage.src = `${Carambola.params.cdn}/media/share-162.svg`;

      if(layout === 162){   
        if(tweet?.post_date) twitterDate.textContent = Carambola.formatPostDate(tweet.post_date);     
        twitterShare.prepend(twitterShareImage);
        twitterShare.addEventListener('click',(e) => {
          e.preventDefault();
          e.stopPropagation();
          Carambola.unitGoToInPopUp(`https://twitter.com/intent/retweet?tweet_id=${tweet.tweet_id}`);
          Carambola.log('click', "Twitter", 31);
        });

        twitterLike.addEventListener('click',(e) => {
          e.preventDefault();
          e.stopPropagation();
          Carambola.unitGoToInPopUp(`https://twitter.com/intent/like?tweet_id=${tweet.tweet_id}`);
          Carambola.log('click', "Twitter", 29);
        });

        twitterMessage.addEventListener('click',(e) => {
          e.preventDefault();
          e.stopPropagation();
          Carambola.unitGoToInPopUp(`https://twitter.com/intent/tweet?in_reply_to=${tweet.tweet_id}&text=`);
          Carambola.log('click', "Twitter", 30);
        });

        const twitterAd = Carambola.createHtmlObject('img', 'carambola-tweet-ad-icon');
        twitterAd.src = `${Carambola.params.cdn}/media/ad.svg`;
        twitterItem.append(twitterAd);
      }

      twitterSvgWrap.append(twitterLikeImage);
      twitterSvgWrap2.append(twitterMessageImage);
      twitterSvgWrap3.append(twitterShareImage);
      twitterLike.append(twitterSvgWrap);
      twitterLike.append(twitterLikeCount);
      twitterMessage.append(twitterSvgWrap2);
      twitterMessage.append(twitterMessageCount);
      twitterShare.prepend(twitterSvgWrap3);
      twitterActions.append(twitterLike);
      twitterActions.append(twitterMessage);
      twitterActions.append(twitterShare);

      if(layout === 162) twitterActions.append(twitterDate);

      twitterFooter.append(twitterActions);
      if(layout === 161) twitterFooter.append(twitterReply);
      twitterItem.append(twitterFooter);

      if(layout === 161 || layout === 163){
        const overlay = Carambola.createHtmlObject("div", "carambola-social-overlay");
        overlay.addEventListener('click', () => {
          const { src, click, platform, iframeSrc } = Carambola.detectObjSocialNetwork(tweet);

          if(isMobile){
            const mobileWrapper = Carambola.createHtmlObject('div', 'carambola-mobile-wrapper'),
                  x = Carambola.createHtmlObject('div', 'carambola-mobile-x');

            x.innerHTML = '&#x2715;';
            x.addEventListener("click", (e)=> { Carambola.closeModal(e); Carambola.log('X'); }, false);
            mobileWrapper.prepend(x);

            if(layout === 161){
              const iframe = document.createElement('iframe');
              iframe.width = 300;
              iframe.height = 600;
              iframe.src = (platform === "Twitter") ? iframeSrc : src;
              iframe.style.border = "0";
              iframe.scrolling = "no";
              mobileWrapper.append(iframe);
      
              const transparentTopDiv = Carambola.createHtmlObject('div', 'transparent-top-div');
              transparentTopDiv.addEventListener("click", ()=> {  Carambola.message(click);  }, false);
              mobileWrapper.append(transparentTopDiv);
      
              const transparentBottomDiv = Carambola.createHtmlObject('div', 'transparent-bottom-div');
              transparentBottomDiv.addEventListener("click", ()=> {  Carambola.message(click); }, false);
              mobileWrapper.append(transparentBottomDiv);
      
              unit.querySelector(".carambola-wrap").prepend(mobileWrapper);
            }
            else {
              unit.querySelector(".carambola-wrap").prepend(mobileWrapper);
              Carambola.message(click);
            }
            clearTimeout(Carambola.params.carouselTimeout);
          } 
          else {
            window.top.open(click , 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
          }

          Carambola.log('click', platform);
        }, false);
        obj.append(overlay);
      }
    }

    obj.setAttribute("rel", index);
    obj.append(twitterItem);

    if(layout === 160) {
      unit.querySelector('.carambola-tweet-message span').textContent = tweet.retweets;
      unit.querySelector('.carambola-tweet-like span').textContent = tweet.favs;
    }

    return obj; 
  }

  Carambola.content152 = (tweet, index, obj) => {
    const twitterItem = Carambola.createHtmlObject('div', 'carambola-tweet-item'),
          twitterTitle = Carambola.createHtmlObject('div', 'carambola-tweet-title'),
          twitterBottom = Carambola.createHtmlObject('div', 'carambola-tweet-bottom'),
          twitterDescription = Carambola.createHtmlObject('div', 'carambola-tweet-description');

    twitterTitle.textContent = "Did You Know?";
    twitterDescription.innerHTML = tweet.description;
    
    twitterItem.append(twitterTitle);
    twitterItem.append(twitterDescription);
    
    twitterBottom.style.backgroundImage = `url("${tweet.media}")`;
    obj.style.backgroundImage = `url("${tweet.media}")`;
    obj.setAttribute("rel", index);
    obj.append(twitterItem);
    obj.append(twitterBottom);
    return obj; 
  }

  Carambola.loadMoreAds = (from = 2) => {
    const ad300Filter = Carambola.inContentAdsList();
    ad300Filter.forEach((el, index) => {
      if(index > from){
        if(index === 1) {
          const postsList = Carambola.params.unit.querySelector(".carambola-social-post"), 
                adPlaceholder = document.createElement("div");
  
          adPlaceholder.className = `carambola-element carambola-social-ad carambola-incontent-${index}`;
          adPlaceholder.dataset.interval = el.adTimer * 1000;
          adPlaceholder.setAttribute("rel", index);
          postsList.parentNode.prepend(adPlaceholder);
        }
        else {
          const postsList = Carambola.params.unit.querySelectorAll(".carambola-social-post"), 
                existingNode = postsList[index - 2],
                adPlaceholder = document.createElement("div");

          adPlaceholder.className = `carambola-element carambola-social-ad carambola-incontent-${index}`;
          adPlaceholder.dataset.interval = el.adTimer * 1000;
          adPlaceholder.setAttribute("rel", index);

          if(existingNode){
            existingNode.parentNode.insertBefore(adPlaceholder, existingNode.nextSibling);
          }
        }
      }
    });
  }

  Carambola.loadMoreAds162 = () => {
    const ad300Filter = Carambola.inContentAdsList();
    ad300Filter.forEach((el, index) => {
      const postsList = Carambola.params.unit.querySelectorAll(".carambola-element"), 
            existingNode = postsList[index - 1];

      if(existingNode){    
        existingNode.classList.add("carambola-social-ad");
        existingNode.classList.add(`carambola-incontent-${index}`);

        existingNode.dataset.interval = el.adTimer * 1000;
        existingNode.setAttribute("rel", index);
      }
    });
  }

  Carambola.loadFirstAd = () => {
    const ad300Filter = Carambola.inContentAdsList(), { layout, unit } = Carambola.params;
    if(!ad300Filter[1]) return false;

    const currentAd = ad300Filter[1],
        { TagScript, refresh } = currentAd,
        adSizeArr = currentAd.size.split("x"),
        adWidth = parseInt(adSizeArr[0]),
        adHeight = parseInt(adSizeArr[1]),
        target = unit.querySelector(".carambola-social-ad.carambola-incontent-1"),
        iframeClass = (layout === 160 || layout === 152) ? `carambola-tweet-ad carambola-left-side-ad-${Carambola.uniqueId()}` : `carambola-left-side-ad-${Carambola.uniqueId()}`;

    if(layout === 160 || layout === 152) target.classList.add("carambola-loaded");

    Carambola.writeDiv(currentAd, target, TagScript, adWidth, adHeight, iframeClass);
    if(refresh) {
      const adIframe = target.querySelectorAll(`.${iframeClass}`);
      if(adIframe && adIframe.length > 0) {
        setInterval(()=>{ 
          if(target.classList.contains('carambola-element-active') || target.classList.contains('carambola-active')){
            target.replaceChildren();
            Carambola.writeDiv(currentAd, target, TagScript, adWidth, adHeight, iframeClass, true);
          }
        }, refresh * 1000);
      }
    }  
  }

  Carambola.loadPost = (target) => {
    const { layout, teleport } = Carambola.params; 
    if (target.classList.contains('carambola-social-post')) {
      const postsList = (Carambola.content.Items) ? Carambola.content.Items : Carambola.getDefaultContent(),
            rel = parseInt(target.getAttribute('rel')),
            currentPost = postsList[rel],
            { src, click, platform, iframeSrc, css } = Carambola.detectObjSocialNetwork(currentPost),
            { w, h, top, left } = Carambola.postScreenPosition(platform),
            { isMobile, unit } = Carambola.params,
            overlay = Carambola.createHtmlObject("div", "carambola-social-overlay");
            
      let socialIframe;
      switch(platform){
        case "Linkedin":
          socialIframe = document.createElement("iframe");
          break;
        case "InstagramText":   
        case "TwitterText":   
        case "Facebook":
        case "Pinterest":
          socialIframe = document.createElement("div");
          break;          
        default:
          socialIframe = document.createElement("blockquote");
      }

      target.classList.add("carambola-loaded");
      if(currentPost?.is_video) overlay.classList.add("carambola-video");

      if(target.classList.contains("undefined")){
        target.classList.remove("undefined");
        target.classList.add(css);
      }

      overlay.addEventListener('click', () => {
        if(isMobile){
          const mobileWrapper = Carambola.createHtmlObject('div', 'carambola-mobile-wrapper'),
                x = Carambola.createHtmlObject('div', 'carambola-mobile-x'); 

          x.innerHTML = '&#x2715;';
          x.addEventListener("click", (e)=> { Carambola.closeModal(e); Carambola.log('X'); }, false);
          mobileWrapper.prepend(x);
  
          let iframe;
          switch(platform){
            case "Bluesky":
              iframe = document.createElement("blockquote");
              break;
            case "InstagramText":  
            case "TwitterText":   
            case "Facebook":  
            case "Pinterest":
              iframe = document.createElement("div");
              break;          
            default:
              iframe = document.createElement("iframe");
          }
          
          iframe.width = (layout === 201) ? 320 : 300;
          iframe.height = (layout === 211 || layout === 161) ? 600 : 400;

          switch (platform) {
            case "Twitter":
              iframe.src = iframeSrc;
              break;
            case "Bluesky":
              iframe.className = "bluesky-embed";
              iframe.dataset.blueskyUri = src;
              const script = document.createElement("script");
              script.async = true;
              script.src = "https://embed.bsky.app/static/embed.js";
              mobileWrapper.append(script);
              break;   
            case "Pinterest":
              iframe.classList.add("carambola-pin-container");
              iframe.style.width = "100%";
              iframe.style.display = "block";

              var a = document.createElement('a');
              a.setAttribute('data-pin-do', 'embedPin');
              a.href = src;
              iframe.appendChild(a);
              break;   
            case "Facebook": 
              Carambola.fbPost(currentPost, iframe);  
              break;               
            case "TwitterText": 
              Carambola.twitPost(currentPost, iframe);  
              break;  
            case "InstagramText":
              Carambola.instaPost(currentPost, iframe); 
              break;                                               
            default:
              iframe.src = src;
          }
          
          iframe.style.border = "0";
          mobileWrapper.append(iframe);
  
          if(platform !== "Facebook" && platform !== "TwitterText" && platform !== "InstagramText"){
            const transparentTopDiv = Carambola.createHtmlObject('div', 'transparent-top-div');
            transparentTopDiv.addEventListener("click", ()=> {  Carambola.message(click);  }, false);
            mobileWrapper.append(transparentTopDiv);
    
            const transparentBottomDiv = Carambola.createHtmlObject('div', 'transparent-bottom-div');
            transparentBottomDiv.addEventListener("click", ()=> {  Carambola.message(click); }, false);
            mobileWrapper.append(transparentBottomDiv);
          }
          else {
            mobileWrapper.addEventListener("click", ()=> {  
              mobileWrapper.innerHTML = '';
              Carambola.message(click);  
            }, false);
          }
          
          unit.querySelector(".carambola-wrap").prepend(mobileWrapper);
          Carambola.unitScrollStop(unit);
          clearTimeout(Carambola.params.carouselTimeout);
          clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
          clearTimeout(Carambola.params.cbolaActiveElementTimeout);

          if(platform === "Pinterest"){
            if(teleport){
              if (window.top.PinUtils && window.top.PinUtils.build) {
                window.top.PinUtils.build();
              }
            } else {
              if (window.PinUtils && window.PinUtils.build) {
                window.PinUtils.build();
              }
            }
          }
        } 
        else {
          window.top.open(click , 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
        }
        Carambola.log('click', platform);
      }, false);

      const socialScript = document.createElement("script");
      switch(platform){
        case "Instagram":
          socialIframe.className = "instagram-media";
          socialIframe.dataset.instgrmPermalink = src.replace("embed","");
          socialIframe.dataset.instgrmVersion = "14";

          socialScript.async = true;
          socialScript.src = "https://www.instagram.com/embed.js";
          break;
        case "Twitter":
          socialIframe.className = "twitter-tweet";

          var a = document.createElement("a");
          a.href = src;

          socialScript.async = true;
          socialScript.src = "https://platform.twitter.com/widgets.js";

          socialIframe.append(a);
          break;
        case "TikTok":
          socialIframe.className = "tiktok-embed";
          socialIframe.dataset.videoId = src.slice(src.lastIndexOf("/") + 1, src.length);

          var a = document.createElement("a");
          a.target = "_blank";

          socialScript.async = true;
          socialScript.src = "https://www.tiktok.com/embed.js";

          socialIframe.append(a);
          break;
        case "YouTubeShorts":
          socialIframe.className = "youtube-shorts-embed";
          socialIframe.dataset.videoId = src.slice(src.lastIndexOf("/") + 1, src.length);

          var a = document.createElement("a");
          a.target = "_blank";

          var youtube_shorts_iframe = document.createElement('iframe');
          youtube_shorts_iframe.width = '100%';
          youtube_shorts_iframe.height = '560';
          youtube_shorts_iframe.src = 'https://www.youtube.com/embed/' + socialIframe.dataset.videoId;
          youtube_shorts_iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          youtube_shorts_iframe.allowFullscreen = true;

          socialIframe.append(a);
          break;
        case "Bluesky":
          socialIframe.className = "bluesky-embed";  
          socialIframe.dataset.blueskyUri = src;
          socialScript.async = true;
          socialScript.src = "https://embed.bsky.app/static/embed.js";
          break;  
        case "Linkedin": 
          socialIframe.src = src;
          break;  
        case "Facebook": 
          Carambola.fbPost(currentPost, socialIframe);
          break; 
        case "TwitterText": 
          Carambola.twitPost(currentPost, socialIframe);  
          break;  
        case "InstagramText":
          Carambola.instaPost(currentPost, socialIframe); 
          break;                          
        case "Pinterest": 
          socialIframe.classList.add("carambola-pin-container");
          socialIframe.style.width = "100%";
          socialIframe.style.display = "block";

          var a = document.createElement('a');
          a.setAttribute('data-pin-do', 'embedPin');
          a.href = src;
          socialIframe.appendChild(a);

          socialScript.async = true;
          socialScript.defer = true;
          socialScript.src = "//assets.pinterest.com/js/pinit.js";
          break;                         
      }

      if(platform !== "Linkedin") target.append(overlay);
      target.append(socialIframe);
      target.append(socialScript);
      if(platform === "YouTubeShorts") target.append(youtube_shorts_iframe);
      Carambola.params.contentCount++;
      if(platform === "Instagram") {
        try { window.top.instgrm.Embeds.process(); } catch (err) {}
        try { window.instgrm.Embeds.process(); } catch (err) {}
      }

      if(platform === "Pinterest") {
        if(teleport){
          if (window.top.PinUtils && window.top.PinUtils.build) {
            window.top.PinUtils.build();
          }
        } else {
          if (window.PinUtils && window.PinUtils.build) {
            window.PinUtils.build();
          }
        }
      }
    }     
  }

  Carambola.userScroll = () =>{
    clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
    Carambola.params.cbolaWheelEventEndTimeout = setTimeout(() => {
      const { unit, layout, isMobile, multi_ad, teleport, collapse_empty_ads }  = Carambola.params,
            targets = unit.querySelectorAll('.carambola-element'),
            ad300Filter = Carambola.inContentAdsList(),
            observerOptions = {
              root: null,
              threshold: 0.01,
            };

      const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
          const target = entry.target;
          const intersectionRatio = entry.intersectionRatio;
          
          if (intersectionRatio >= observerOptions.threshold) {
            target.classList.add('carambola-element-active');
            if(multi_ad && Carambola.params.widgetLoad && [211, 201, 202].includes(layout)) Carambola.loadThreeAds(target);

            try {
              let adNum = parseInt(target.getAttribute('rel'));
              if(target.classList.contains('carambola-social-ad') && !target.classList.contains('carambola-check-if-ad-exist') && ad300Filter[adNum]){
                if([211, 202, 201].includes(layout)) {
                  target.classList.add('carambola-check-if-ad-exist');
                  
                  setTimeout(() => {
                    if(target.querySelector("iframe")) {
                      Carambola.log("AdDelivered");
                      target.classList.add('carambola-ad-exist');
                    }
                  }, 2000);

                  setTimeout(() => {
                    if(target.querySelector("iframe") && !target.classList.contains("carambola-ad-exist")) {
                      Carambola.log("AdDelivered");
                      target.classList.add('carambola-ad-exist');
                    }
                    if(!target.querySelector("iframe") && collapse_empty_ads && ad300Filter[adNum].TagScript.includes("window.asc.processAdsOnPage")) target.remove();
                  }, 5000);

                }
              }
            } catch (error) {}

            if(!target.classList.contains("carambola-loaded")) {
              const rel = parseInt(target.getAttribute('rel'));
              target.classList.add('carambola-loaded');

              if(target.classList.contains('carambola-social-ad') && ad300Filter[rel]){
                const currentAd = ad300Filter[rel],
                      { TagScript, refresh } = currentAd,
                      adSizeArr = currentAd.size.split("x"),
                      adWidth = parseInt(adSizeArr[0]),
                      adHeight = parseInt(adSizeArr[1]),
                      iframeClass = `carambola-left-side-ad-${Carambola.uniqueId()}`;
          
                Carambola.writeDiv(currentAd, target, TagScript, 300, adHeight, iframeClass);

                if(refresh) {
                  const adIframe = target.querySelectorAll(`.${iframeClass}`);
                  if(adIframe && adIframe.length > 0) {
                    setInterval(()=>{ 
                      if(target.classList.contains('carambola-element-active')){
                        target.replaceChildren();
                        Carambola.writeDiv(currentAd, target, TagScript, 300, adHeight, iframeClass, true);
                      }
                    }, refresh * 1000);
                  }
                }  
              }
              else if (target.classList.contains('carambola-social-post')) {
                const postsList = (Carambola.content.Items) ? Carambola.content.Items : Carambola.getDefaultContent(),
                      currentPost = postsList[rel],
                      { src, click, platform, iframeSrc } = Carambola.detectObjSocialNetwork(currentPost),
                      { w, h, top, left } = Carambola.postScreenPosition(platform),
                      overlay = Carambola.createHtmlObject("div", "carambola-social-overlay");

                let socialIframe;
                switch(platform){
                  case "Linkedin":
                    socialIframe = document.createElement("iframe");
                    break;
                  case "InstagramText":
                  case "TwitterText":   
                  case "Facebook":  
                  case "Pinterest":
                    socialIframe = document.createElement("div");
                    break;          
                  default:
                    socialIframe = document.createElement("blockquote");
                }

                if(layout === 211 || layout === 202 || layout === 201 || layout === 161){

                  if((layout === 211 || layout === 202 || layout === 201) && currentPost?.is_video){
                    overlay.classList.add("carambola-video");
                  }

                  overlay.addEventListener('click', () => {
                    if(isMobile){
                      const mobileWrapper = Carambola.createHtmlObject('div', 'carambola-mobile-wrapper'),
                            x = Carambola.createHtmlObject('div', 'carambola-mobile-x'); 

                      x.innerHTML = '&#x2715;';
                      x.addEventListener("click", (e)=> { Carambola.closeModal(e); Carambola.log('X'); }, false);
                      mobileWrapper.prepend(x);
              
                      let iframe;
                      switch(platform){
                        case "Bluesky":
                          iframe = document.createElement("blockquote");
                          break;
                        case "InstagramText":  
                        case "TwitterText":   
                        case "Facebook":   
                        case "Pinterest":
                          iframe = document.createElement("div");
                          break;          
                        default:
                          iframe = document.createElement("iframe");
                      }

                      iframe.width = (layout === 201) ? 320 : 300;
                      iframe.height = (layout === 211 || layout === 161) ? 600 : 400;

                      switch (platform) {
                        case "Twitter":
                          iframe.src = iframeSrc;
                          break;
                        case "Bluesky":
                          iframe.className = "bluesky-embed";
                          iframe.dataset.blueskyUri = src;
                          const script = document.createElement("script");
                          script.async = true;
                          script.src = "https://embed.bsky.app/static/embed.js";
                          mobileWrapper.append(script);
                          break; 
                        case "Pinterest":
                          iframe.classList.add("carambola-pin-container");
                          iframe.style.width = "100%";
                          iframe.style.display = "block";
      
                          var a = document.createElement('a');
                          a.setAttribute('data-pin-do', 'embedPin');
                          a.href = src;
                          iframe.appendChild(a);
                          break;   
                        case "Facebook": 
                          Carambola.fbPost(currentPost, iframe);
                          break; 
                        case "TwitterText": 
                          Carambola.twitPost(currentPost, iframe);  
                          break;   
                        case "InstagramText":
                          Carambola.instaPost(currentPost, iframe); 
                          break;                                                                        
                        default:
                          iframe.src = src;
                      }

                      iframe.style.border = "0";
                      mobileWrapper.append(iframe);
              
                      if(platform !== "Facebook" && platform !== "TwitterText" && platform !== "InstagramText"){
                        const transparentTopDiv = Carambola.createHtmlObject('div', 'transparent-top-div');
                        transparentTopDiv.addEventListener("click", ()=> {  Carambola.message(click);  }, false);
                        mobileWrapper.append(transparentTopDiv);
                
                        const transparentBottomDiv = Carambola.createHtmlObject('div', 'transparent-bottom-div');
                        transparentBottomDiv.addEventListener("click", ()=> {  Carambola.message(click); }, false);
                        mobileWrapper.append(transparentBottomDiv);
                      }
                      else {
                        mobileWrapper.addEventListener("click", ()=> {  
                          mobileWrapper.innerHTML = ''; 
                          Carambola.message(click);  
                        }, false);
                      }

                      unit.querySelector(".carambola-wrap").prepend(mobileWrapper);
                      Carambola.unitScrollStop(unit);
                      clearTimeout(Carambola.params.carouselTimeout);
                      clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
                      clearTimeout(Carambola.params.cbolaActiveElementTimeout);

                      if(platform === "Pinterest"){
                        if(teleport){
                          if (window.top.PinUtils && window.top.PinUtils.build) {
                            window.top.PinUtils.build();
                          }
                        } else {
                          if (window.PinUtils && window.PinUtils.build) {
                            window.PinUtils.build();
                          }
                        }
                      }
                    } 
                    else {
                      window.top.open(click , 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
                    }
                    Carambola.log('click', platform);
                  }, false);
                } 
                else {
                  overlay.addEventListener('click', () => {
                    window.top.open(click , 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
                    Carambola.log('click', platform);
                  }, false);
                }
                

                const socialScript = document.createElement("script");
                switch(platform){
                  case "Instagram":
                    socialIframe.className = "instagram-media";
                    socialIframe.dataset.instgrmPermalink = src.replace("embed","");
                    socialIframe.dataset.instgrmVersion = "14";

                    socialScript.async = true;
                    socialScript.src = "https://www.instagram.com/embed.js";
                    break;
                  case "Twitter":
                    socialIframe.className = "twitter-tweet";

                    var a = document.createElement("a");
                    a.href = src;

                    socialScript.async = true;
                    socialScript.src = "https://platform.twitter.com/widgets.js";

                    socialIframe.append(a);
                    break;
                  case "TikTok":
                    socialIframe.className = "tiktok-embed";
                    socialIframe.dataset.videoId = src.slice(src.lastIndexOf("/") + 1, src.length);
          
                    var a = document.createElement("a");
                    a.target = "_blank";

                    socialScript.async = true;
                    socialScript.src = "https://www.tiktok.com/embed.js";

                    socialIframe.append(a);
                    break;
                  case "YouTubeShorts":
                    socialIframe.className = "youtube-shorts-embed";
                    socialIframe.dataset.videoId = src.slice(src.lastIndexOf("/") + 1, src.length);
          
                    var a = document.createElement("a");
                    a.target = "_blank";

                    var youtube_shorts_iframe = document.createElement('iframe');
                    youtube_shorts_iframe.width = '100%';
                    youtube_shorts_iframe.height = '560';
                    youtube_shorts_iframe.src = 'https://www.youtube.com/embed/' + socialIframe.dataset.videoId;
                    youtube_shorts_iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                    youtube_shorts_iframe.allowFullscreen = true;

                    socialIframe.append(a);
                    break;
                  case "Bluesky":
                    socialIframe.className = "bluesky-embed";  
                    socialIframe.dataset.blueskyUri = src;
                    socialScript.async = true;
                    socialScript.src = "https://embed.bsky.app/static/embed.js";
                    break;
                  case "Linkedin": 
                    socialIframe.src = src;
                    break;  
                  case "Facebook": 
                    Carambola.fbPost(currentPost, socialIframe);
                    break;
                  case "TwitterText": 
                    Carambola.twitPost(currentPost, socialIframe);  
                    break;    
                  case "InstagramText":
                    Carambola.instaPost(currentPost, socialIframe); 
                    break;                                    
                  case "Pinterest": 
                    socialIframe.classList.add("carambola-pin-container");
                    socialIframe.style.width = "100%";
                    socialIframe.style.display = "block";

                    var a = document.createElement('a');
                    a.setAttribute('data-pin-do', 'embedPin');
                    a.href = src;
                    socialIframe.appendChild(a);

                    socialScript.async = true;
                    socialScript.defer = true;
                    socialScript.src = "//assets.pinterest.com/js/pinit.js";
                    break;                                         
                }

                if(platform !== "Linkedin") target.append(overlay);
                target.append(socialIframe);
                target.append(socialScript);
                if(platform === "YouTubeShorts")
                {
                  target.append(youtube_shorts_iframe);
                }
                Carambola.params.contentCount++;
                if(platform === "Instagram") {
                  try { window.top.instgrm.Embeds.process(); } catch (err) {}
                  try { window.instgrm.Embeds.process(); } catch (err) {}
                }

                if(platform === "Pinterest") {
                  if(teleport){
                    if (window.top.PinUtils && window.top.PinUtils.build) {
                      window.top.PinUtils.build();
                    }
                  } else {
                    if (window.PinUtils && window.PinUtils.build) {
                      window.PinUtils.build();
                    }
                  }
                }

                Carambola.follow();

                if([211, 202, 201].includes(layout)) Carambola.loadThreePosts(target); 
              }
            }
          }
          else {
            target.classList.remove('carambola-element-active');
          }
        });

        Carambola.oneActive(Carambola.params.unit);
      };

      const observer = new IntersectionObserver(handleIntersection, observerOptions);
      targets.forEach(target => observer.observe(target)); 
    }, 100);
  }

  Carambola.loadThreeAds = (currentPost) => {
    let adElements = [],
        { did } = Carambola.params,
        showAds = (did === 2846) ? 6 : 3; 
        sibling = currentPost.nextElementSibling;
      
    while (sibling && adElements.length < showAds) {
      if (sibling.classList.contains('carambola-social-ad') && !sibling.classList.contains('carambola-loaded')) {
        adElements.push(sibling);
      }
      else if(sibling.classList.contains('carambola-social-ad') && sibling.classList.contains('carambola-loaded')){
        adElements = [];
        break;
      }
      sibling = sibling.nextElementSibling;
    }

    if(adElements.length > 0) adElements.forEach(el => { Carambola.loadAd(el); });  
  }

  Carambola.loadThreePosts = (currentPost) => {
    let adElements = [],
        sibling = currentPost.nextElementSibling;
        
    while (sibling && adElements.length < 2) {
      if (sibling.classList.contains('carambola-social-post') && !sibling.classList.contains('carambola-loaded')) {
        adElements.push(sibling);
      }
      else if(sibling.classList.contains('carambola-social-post') && sibling.classList.contains('carambola-loaded')){
        adElements = [];
        break;
      }
      sibling = sibling.nextElementSibling;
    }

    if(adElements.length > 0) adElements.forEach(el => { Carambola.loadPost(el); });  
  }

  Carambola.loadAd = (target) => {
    const ad300Filter = Carambola.inContentAdsList();
    const rel = parseInt(target.getAttribute('rel')),
          currentAd = ad300Filter[rel],
          { TagScript, refresh } = currentAd,
          adSizeArr = currentAd.size.split("x"),
          adHeight = parseInt(adSizeArr[1]),
          iframeClass = `carambola-left-side-ad-${Carambola.uniqueId()}`;
    
    target.classList.add('carambola-loaded');
    Carambola.writeDiv(currentAd, target, TagScript, 300, adHeight, iframeClass);

    if(refresh) {
      const adIframe = target.querySelectorAll(`.${iframeClass}`);
      if(adIframe && adIframe.length > 0) {
        setInterval(() => { 
          if(target.classList.contains('carambola-element-active')){
            target.replaceChildren();
            Carambola.writeDiv(currentAd, target, TagScript, 300, adHeight, iframeClass, true);
          }
        }, refresh * 1000);
      }
    }     
  }

  Carambola.userScroll162 = () =>{
    clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
    Carambola.params.cbolaWheelEventEndTimeout = setTimeout(() => {
      const targets = Carambola.params.unit.querySelectorAll('.carambola-element'),
      ad300Filter = Carambola.inContentAdsList(),
      observerOptions = {
        root: null,
        threshold: 0.01,
      };

      const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
          const target = entry.target;
          const intersectionRatio = entry.intersectionRatio;
          
          if (intersectionRatio >= observerOptions.threshold) {
            target.classList.add('carambola-element-active');

            if(!target.classList.contains("carambola-loaded")) {
              const rel = parseInt(target.getAttribute('rel'));
              target.classList.add('carambola-loaded');

              if(target.classList.contains('carambola-social-ad') && ad300Filter[rel]){
                const currentAd = ad300Filter[rel],
                      adWrapper = target.querySelector(".carambola-right-placeholder"),
                      { TagScript, refresh } = currentAd,
                      adSizeArr = currentAd.size.split("x"),
                      adWidth = parseInt(adSizeArr[0]),
                      adHeight = parseInt(adSizeArr[1]),
                      iframeClass = `carambola-left-side-ad-${Carambola.uniqueId()}`;
                
                adWrapper.replaceChildren();
                Carambola.writeDiv(currentAd, adWrapper, TagScript, 300, adHeight, iframeClass);

                if(refresh) {
                  const adIframe = adWrapper.querySelectorAll(`.${iframeClass}`);
                  if(adIframe && adIframe.length > 0) {
                    setInterval(()=>{ 
                      if(target.classList.contains('carambola-element-active')){
                        adWrapper.replaceChildren();
                        Carambola.writeDiv(currentAd, adWrapper, TagScript, 300, adHeight, iframeClass, true);
                      }
                    }, refresh * 1000);
                  }
                }         
              }
              else {
                Carambola.params.contentCount++;
              }
            }
          }
          else {
            target.classList.remove('carambola-element-active');
          }
        });

        Carambola.oneActive(Carambola.params.unit);
      };

      const observer = new IntersectionObserver(handleIntersection, observerOptions);
      targets.forEach(target => observer.observe(target)); 
    }, 100);
  }

  Carambola.renderUnit = () => {
    const wrap = document.createElement("div"),
          { layout, click_expend, did, pid, wid, widget_title, widget_title_font, widget_frame_width, InContentTitleColor, InContentTitleBackgroundColor, InContentUnitBackgroundColor, InContentUnitFrameColor } = Carambola.params;

    wrap.className = `carambola-wrap carambola-layout-${layout}`;

    let carambolaHoverStartTime;
    wrap.addEventListener("mouseenter", function(e) {
      carambolaHoverStartTime = Date.now(); 
    });
    
    wrap.addEventListener("mouseleave", function(e) {
      const hoverTime = Date.now() - carambolaHoverStartTime; 
      Carambola.params.totalHover += hoverTime;
    });

    const logoWrap = document.createElement("div");
    logoWrap.className = "carambola-wrap-logo";

    const logo = document.createElement("a");
    logo.className = "carambola-logo";
    logo.target = "_blank";
    logo.href = "https://carambola.com/";
    logo.addEventListener("click", () => {
      Carambola.log("LogoClick");
    });

    logoWrap.append(logo);

    switch(layout) {
        case 201:   
        case 202:  
        case 211:
        case 161:
        case 163:  
          const instaWrap211 = document.createElement('div');
          instaWrap211.classList.add('carambola-social-wrapper');
          instaWrap211.classList.add('carambola-scrollbar');

          Carambola.scrollOne = () => { 
            Carambola.log('scroll');
            instaWrap211.removeEventListener('touchmove', Carambola.scrollOne, false);
            instaWrap211.removeEventListener('wheel', Carambola.scrollOne, false);
          }

          instaWrap211.addEventListener('touchmove', Carambola.scrollOne, false);
          instaWrap211.addEventListener('wheel', Carambola.scrollOne, false);

          Carambola.userScroll();
          instaWrap211.addEventListener("scroll", () => { 
            Carambola.userScroll(); 
            
            let scrollWrap = Carambola.params.unit.querySelector('.carambola-scroll-wrapper');
            if(scrollWrap !== null){
              scrollWrap.remove();
            }
          }, false);

          var hoverDuration = null;
          instaWrap211.addEventListener('mouseenter', () => {
            hoverDuration = new Date();
          }, false);

          Carambola.hoverDuration = () => { 
            if(new Date() - hoverDuration >= 2000){
              Carambola.log('hover');
              instaWrap211.removeEventListener('mouseleave', Carambola.hoverDuration, false);
            }
          }

          instaWrap211.addEventListener('mouseleave', Carambola.hoverDuration, false);

          if([211, 201, 202].includes(layout)) {
            instaWrap211.addEventListener("mouseover", () => {
              instaWrap211.classList.add("carambola-hover");
            });
          
            instaWrap211.addEventListener("mouseout", () => {
              instaWrap211.classList.remove("carambola-hover");
              Carambola.checkIfInViewport();
            });
          }

          const socialContent211 = Carambola.createHtmlObject("div", "carambola-social-content"),
                outOfFrame = Carambola.ads.filter(ad => ad.adType === "outOfFrame").length > 0;

          if(outOfFrame){
            const bannerWrap211 = document.createElement('div');
            bannerWrap211.classList.add('carambola-vertical-ad-wrapper');
  
            const bannerContent211 = document.createElement('div');
            bannerContent211.classList.add('carambola-vertical-ad');
  
            bannerWrap211.append(bannerContent211);
            instaWrap211.append(socialContent211);
            wrap.append(instaWrap211);
            if(layout !== 202 && layout !== 201) wrap.append(logo);          
            wrap.append(bannerWrap211);
          }
          else {
            instaWrap211.append(socialContent211);
            wrap.classList.add('carambola-no-outofframe');
            wrap.append(instaWrap211);
            if(layout !== 202 && layout !== 201) wrap.append(logo);        
          }
          break;  
        case 162:  
          var tweetsWrap = Carambola.createHtmlObject('div', 'carambola-social-wrapper carambola-scrollbar'),
              tweetsList = Carambola.createHtmlObject('div', 'carambola-social-content');

          var hoverDuration = null;
          wrap.addEventListener('mouseenter', () => {
            hoverDuration = new Date();
          }, false);

          Carambola.hoverDuration = () => { 
            if(new Date() - hoverDuration >= 2000){
              Carambola.log('hover');
              wrap.removeEventListener('mouseleave', Carambola.hoverDuration, false);
            }
          }

          Carambola.mouseEnter = () => { 
            wrap.removeEventListener('mouseenter', Carambola.mouseEnter, false);
          }

          Carambola.scrollOne = () => { 
            Carambola.log('scroll');
            tweetsWrap.removeEventListener('touchmove', Carambola.scrollOne, false);
            tweetsWrap.removeEventListener('wheel', Carambola.scrollOne, false);
          }

          tweetsWrap.addEventListener('touchmove', Carambola.scrollOne, false);
          tweetsWrap.addEventListener('wheel', Carambola.scrollOne, false);

          Carambola.userScroll162();
          tweetsWrap.addEventListener("scroll", () => { 
            Carambola.userScroll162(); 
            
            let scrollWrap = Carambola.params.unit.querySelector('.carambola-scroll-wrapper');
            if(scrollWrap !== null){
              scrollWrap.remove();
            }
          }, false);

          wrap.addEventListener('mouseleave', Carambola.hoverDuration, false);
          wrap.addEventListener('mouseenter', Carambola.mouseEnter, false);
          tweetsWrap.append(tweetsList);
          wrap.append(logo);
          wrap.append(tweetsWrap);
          break; 
        case 152:
          var   arrowPrev = Carambola.createHtmlObject("div", "carambola-icon carambola-prev"),
                arrowNext = Carambola.createHtmlObject("div", "carambola-icon carambola-next"),
                arrow = Carambola.createHtmlObject('div', 'carambola-arrow'),
                tempSpan = document.createElement('span'),
                tweetsWrap = Carambola.createHtmlObject('div', 'carambola-tweets-wrap'),
                tweetsList = Carambola.createHtmlObject('div', 'carambola-tweets-list');

                arrow.append(tempSpan);
                arrowPrev.append(arrow);
                arrowNext.append(arrow.cloneNode(true));

                arrowNext.addEventListener("click", (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Carambola.nextTweet();
                  Carambola.log("ClickNext");
                });
                
                arrowPrev.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if(Carambola.params.currentPost > 0){
                      tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost].classList.remove("carambola-active");
                      Carambola.params.currentPost -= 1;
                      const newTweet = tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost];
                      newTweet.classList.add("carambola-active");

                      Carambola.setTimeoutNext();
                      Carambola.log("ClickPrevious");
                    }
                    tweetsWrap.scrollLeft = 300 * Carambola.params.currentPost;
                });
      
                var hoverDuration = null;
                wrap.addEventListener('mouseenter', () => {
                  hoverDuration = new Date();
                }, false);
      
                Carambola.hoverDuration = () => { 
                  if(new Date() - hoverDuration >= 2000){
                    Carambola.log('hover');
                    wrap.removeEventListener('mouseleave', Carambola.hoverDuration, false);
                  }
                }
      
                Carambola.mouseEnter = () => { 
                  wrap.removeEventListener('mouseenter', Carambola.mouseEnter, false);
                }
      
                wrap.addEventListener('mouseleave', Carambola.hoverDuration, false);
                wrap.addEventListener('mouseenter', Carambola.mouseEnter, false);
                
                tweetsWrap.append(tweetsList);
                wrap.append(logo);
                wrap.append(arrowPrev);
                wrap.append(arrowNext);
                wrap.append(tweetsWrap);               
          break;           
        case 160:
          var x = Carambola.createHtmlObject('img', 'carambola-logo-x'),
                arrowPrev = Carambola.createHtmlObject("div", "carambola-prev"),
                arrowNext = Carambola.createHtmlObject("div", "carambola-next"),
                tweetsWrap = Carambola.createHtmlObject('div', 'carambola-tweets-wrap'),
                tweetsList = Carambola.createHtmlObject('div', 'carambola-tweets-list'),
                twitterFooter = Carambola.createHtmlObject('div', 'carambola-tweet-footer'),
                twitterActions = Carambola.createHtmlObject('div', 'carambola-tweet-actions'),
                twitterLike = Carambola.createHtmlObject('div', 'carambola-tweet-like'),
                twitterLikeCount = document.createElement('span'),
                twitterSvgWrap = Carambola.createHtmlObject('div', 'carambola-tweet-svg-wrap'),
                twitterLikeImage = document.createElement('img'),
                twitterMessage = Carambola.createHtmlObject('div', 'carambola-tweet-message'),
                twitterMessageCount = document.createElement('span'),
                twitterSvgWrap2 = Carambola.createHtmlObject('div', 'carambola-tweet-svg-wrap'),
                twitterMessageImage = document.createElement('img'),
                twitterReply = Carambola.createHtmlObject('div', 'carambola-tweet-reply'),
                twitterReplyCount = Carambola.createHtmlObject('div', 'carambola-tweet-reply-count'),
                twitterReplyButton = Carambola.createHtmlObject('button', 'carambola-tweet-reply-send carambola-disable'),
                twitterReplyInput = Carambola.createHtmlObject('input', 'carambola-tweet-reply-input'),
                twitterFollow = Carambola.createHtmlObject('div', 'carambola-tweet-follow');

          x.src = `${Carambola.params.cdn}/media/x.svg`;
          twitterFollow.textContent = 'Follow';      
          twitterLikeImage.src = `${Carambola.params.cdn}/media/like.svg`;
          twitterMessageImage.src = `${Carambola.params.cdn}/media/message.svg`;
          twitterReplyCount.textContent = '140';
          twitterReplyButton.textContent = 'Send';
          twitterReplyInput.placeholder = 'Reply Here';
          twitterReplyInput.type = 'text';
          twitterReplyInput.maxLength="140";

          twitterReplyInput.addEventListener('keyup',(e) => { 
            const inputValueLength = e.target.value.length;
            twitterReplyCount.textContent = 140 - inputValueLength;
            if(inputValueLength > 0) {
              twitterReplyButton.classList.remove('carambola-disable');
            } else {
              twitterReplyButton.classList.add('carambola-disable');
            }
          });
          
          twitterFollow.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            Carambola.unit160Actions("follow");
          });

          twitterLike.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            Carambola.unit160Actions("like");
          });

          twitterMessage.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            Carambola.unit160Actions("retweet");
          });

          twitterReplyButton.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            if(!twitterReplyButton.classList.contains('carambola-disable')) {
              Carambola.unit160Actions(twitterReplyInput.value);
            }
          });

          arrowNext.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            Carambola.nextTweet();
            Carambola.log("ClickNext");
          });
          
          arrowPrev.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              if(Carambola.params.currentPost > 0){
                tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost].classList.remove("carambola-active");
                Carambola.params.currentPost -= 1;
                const newTweet = tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost], 
                      { layout, unit } = Carambola.params, 
                      index = newTweet.getAttribute("rel");
                newTweet.classList.add("carambola-active");
                if(newTweet.classList.contains("carambola-social-post")){
                  const element = (Carambola.content?.Items) ? Carambola.content.Items[index] : Carambola.getDefaultContent()[index];
                  unit.querySelector('.carambola-tweet-message span').textContent = element.retweets;
                  unit.querySelector('.carambola-tweet-like span').textContent = element.favs;
                }
                Carambola.setTimeoutNext();
                Carambola.log("ClickPrevious");
              }
              tweetsWrap.scrollLeft = 728 * Carambola.params.currentPost;
          });

          var hoverDuration = null;
          wrap.addEventListener('mouseenter', () => {
            hoverDuration = new Date();
          }, false);

          Carambola.hoverDuration = () => { 
            if(new Date() - hoverDuration >= 2000){
              Carambola.log('hover');
              wrap.removeEventListener('mouseleave', Carambola.hoverDuration, false);
            }
          }

          Carambola.mouseEnter = () => { 
            wrap.removeEventListener('mouseenter', Carambola.mouseEnter, false);
          }

          wrap.addEventListener('mouseleave', Carambola.hoverDuration, false);
          wrap.addEventListener('mouseenter', Carambola.mouseEnter, false);

          twitterReply.append(twitterReplyInput);
          twitterReply.append(twitterReplyCount);
          twitterReply.append(twitterReplyButton);
          twitterSvgWrap.append(twitterLikeImage);
          twitterSvgWrap2.append(twitterMessageImage);
          twitterLike.append(twitterSvgWrap);
          twitterLike.append(twitterLikeCount);
          twitterMessage.append(twitterSvgWrap2);
          twitterMessage.append(twitterMessageCount);
          twitterActions.append(twitterFollow);
          twitterActions.append(twitterLike);
          twitterActions.append(twitterMessage);
          twitterFooter.append(twitterActions);
          twitterFooter.append(twitterReply);
          tweetsWrap.append(tweetsList);
          wrap.append(logo);
          wrap.append(x);
          wrap.append(arrowPrev);
          wrap.append(arrowNext);
          wrap.append(tweetsWrap);
          wrap.append(twitterFooter);
          break;             
    }

    if(Carambola.params.scriptSRC.includes("route.carambo.la") || Carambola.params.scriptSRC.includes("ab-routing.carambo.la") || did === 2971){
      Carambola.params.container = `carambola_legacy_${pid}_${did}_${wid}`;
      const newWrapper = document.createElement("div");
      newWrapper.id = Carambola.params.container;
      document.querySelector(`.carambola_InContent`).insertAdjacentElement('afterend', newWrapper);
    }

    try{
      if(did === 2565){
        let h2_prefix = 'How Many Words can be Made From';
        let h2_prefix_2 = 'Unscrambled Words using the letters';
        let h2_full_text = 'Word Game Tile/Letters';     
        let allH2 = document.querySelectorAll('h2');
        let originUnit = document.querySelector(`#${Carambola.params.container}`);
        for (let h2 of allH2) {
          if (h2.textContent.trim().startsWith(h2_prefix) || h2.textContent.trim().startsWith(h2_prefix_2)) {
            let h2_parentEl = h2.parentElement;
            originUnit.remove();
            h2_parentEl.parentElement.insertBefore(originUnit, h2_parentEl);
            break;
          }
        }  
      }                  
    }
    catch(err){console.log(err);}    
    
    try{
      if(did === 2845 && Carambola.params.isMobile){
          let originUnit = document.querySelector(`#${Carambola.params.container}`);
          let parentElementReplace = document.getElementById('id-sec-example-sentences');
          if(!parentElementReplace && window.location.href.includes("/carambola-test")){
            const justEmptyDiv = document.createElement("div");
            parentElementReplace = document.createElement("div");
            parentElementReplace.id = "example-sentences";
            justEmptyDiv.append(parentElementReplace);
            document.querySelector('#content').append(justEmptyDiv);
          }
          originUnit.remove();
          if(parentElementReplace) {
            originUnit.style.marginBottom = "20px";
            parentElementReplace.prepend(originUnit); //  parentElementReplace.parentElement.insertBefore(originUnit, parentElementReplace);
          }
      } 
      if(did === 2846 && Carambola.params.isMobile){
          let originUnit = document.querySelector(`#${Carambola.params.container}`);
          let parentElementReplace = document.getElementById('example-sentences');
          originUnit.remove();
          parentElementReplace.parentElement.insertBefore(originUnit, parentElementReplace);
      }                  
    }
    catch(err){console.log(err);}      
    
    Carambola.params = {...Carambola.params, unit: document.querySelector(`#${Carambola.params.container}`)};

    try {
      if(widget_title){
        const widgetTitle = Carambola.createHtmlObject("div", "carambola-title");
        widgetTitle.textContent = widget_title;
        if(widget_title_font) widgetTitle.style.fontFamily = widget_title_font;
        if(InContentTitleColor) widgetTitle.style.color = InContentTitleColor;
        if(InContentTitleBackgroundColor) widgetTitle.style.backgroundColor = InContentTitleBackgroundColor;
        Carambola.params.unit.append(widgetTitle);
      }

      if(widget_frame_width) wrap.style.borderWidth = widget_frame_width;
      if(InContentUnitFrameColor) wrap.style.borderColor = InContentUnitFrameColor;
      if(InContentUnitBackgroundColor) {
        wrap.style.backgroundColor = InContentUnitBackgroundColor;

        const scrollStyle = (Carambola.params?.teleport) ? window.top.document.querySelector(".carambola-style") : document.querySelector(".carambola-style");
        if(scrollStyle){
          scrollStyle.append(
            ` .carambola-scrollbar::-webkit-scrollbar-track {
              background-color: ${InContentUnitBackgroundColor} !important;
            }
        
            .carambola-scrollbar::-webkit-scrollbar-thumb {
                border:5px solid ${InContentUnitBackgroundColor} !important;
            }`
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
    
    Carambola.params.unit.append(wrap);

    try {
      if([211, 201, 202].includes(layout) && click_expend) {
        const expendWrap = Carambola.createHtmlObject('div', 'carambola-wrap-expend'),
              expendBtn = Carambola.createHtmlObject('div', 'carambola-expend-button');

        expendBtn.textContent = "Expend";

        expendBtn.addEventListener('click', () => {
          Carambola.params.unit.querySelector(".carambola-wrap-expend").remove();
          Carambola.params.unit.classList.remove("carambola-expend");
        });      

        expendWrap.append(expendBtn);
        if(widget_title) expendWrap.style.top = "160px";
        Carambola.params.unit.classList.add("carambola-expend");
        Carambola.params.unit.querySelector(".carambola-wrap").append(expendWrap);
      }

      if(widget_title){
        Carambola.params.unit.querySelector(".carambola-title").style.width = "100%";
      }
    } catch (error) {
      console.log(error);
    }
  }

  Carambola.nextTweet = () => {
    const { unit, layout, multi_ad, container } = Carambola.params,
    tweetsWrap = unit.querySelector('.carambola-tweets-wrap'),
    tweetsList = unit.querySelector('.carambola-tweets-list');
    
    if(Carambola.params.currentPost + 1 === tweetsList.querySelectorAll(".carambola-element").length) {
      clearTimeout(Carambola.params.carouselTimeout);
      clearTimeout(Carambola.params.cbolaWheelEventEndTimeout);
      clearTimeout(Carambola.params.cbolaActiveElementTimeout);
      
      if(layout === 152) {
        document.querySelector(`#${container}`).innerHTML = '';
        let layoutStyleExternal = document.querySelector(`.carambola-external-style-layout-${layout}`);
        if(layoutStyleExternal) layoutStyleExternal.remove();            
        let layoutStyle = document.querySelector(`.carambola-style-layout-${layout}`);
        if(layoutStyle) layoutStyle.remove();
        Carambola.renderStyle();
        Carambola.renderUnit();
        if(Carambola?.content?.Items) Carambola.parseResponse(Carambola.content.Items);
        else Carambola.jsonError();
        Carambola.params.currentPost = 0;
      }

      return false;
    }

    if(Carambola.params.currentPost + 1 < tweetsList.querySelectorAll(".carambola-element").length){
      tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost].classList.remove("carambola-active");
      Carambola.params.currentPost += 1;
      const newTweet = tweetsList.querySelectorAll(".carambola-element")[Carambola.params.currentPost], 
            index = newTweet.getAttribute("rel");

      newTweet.classList.add("carambola-active");

      if(!newTweet.classList.contains("carambola-loaded")){
        newTweet.classList.add("carambola-loaded");
        if(newTweet.classList.contains("carambola-social-post")){
          const element = (Carambola.content?.Items) ? Carambola.content.Items[index] : Carambola.getDefaultContent()[index];
          if(layout !== 152) Carambola.tweets160(element, index, newTweet);
          else {
            if(multi_ad) Carambola.loadThreeAds(newTweet);
            Carambola.content152(element, index, newTweet);
          }
          Carambola.params.contentCount++;
        }
        else {
          const ad728Filter = Carambola.inContentAdsList(),
                currentAd = ad728Filter[index],
                  { TagScript, refresh } = currentAd,
                  adWidth = (layout === 152) ? 300 : 728,
                  adHeight = (layout === 152) ? 250 : 90,
                  iframeClass = `carambola-tweet-ad-${Carambola.uniqueId()}`;
      
            Carambola.writeDiv(currentAd, newTweet, TagScript, adWidth, adHeight, `carambola-tweet-ad ${iframeClass}`);

            if(refresh) {
              const adIframe = newTweet.querySelectorAll(`.${iframeClass}`);
              if(adIframe && adIframe.length > 0) {
                setInterval(()=>{ 
                  if(newTweet.classList.contains('carambola-active')){
                    newTweet.replaceChildren();
                    Carambola.writeDiv(currentAd, newTweet, TagScript, adWidth, adHeight, `carambola-tweet-ad ${iframeClass}`, true);
                  }
                }, refresh * 1000);
              }
            } 
        }
      } else {
        if(newTweet.classList.contains("carambola-social-post")){
          const element = (Carambola.content?.Items) ? Carambola.content.Items[index] : Carambola.getDefaultContent()[index];
          if(layout === 160) unit.querySelector('.carambola-tweet-message span').textContent = element.retweets;
          if(layout !== 152) unit.querySelector('.carambola-tweet-like span').textContent = element.favs;
        }
      }

      if(layout === 152 && newTweet.classList.contains("carambola-social-ad") && !newTweet.classList.contains('carambola-check-if-ad-exist')){
        newTweet.classList.add('carambola-check-if-ad-exist');
        setTimeout(() => {
          if(newTweet.querySelector("iframe")) {
            Carambola.log("AdDelivered");
            newTweet.classList.add('carambola-ad-exist');
          }
        }, 2000);
      }

      Carambola.setTimeoutNext();
    } 
    if(layout === 160) tweetsWrap.scrollLeft = 728 * Carambola.params.currentPost;
    if(layout === 152) tweetsWrap.scrollLeft = 300 * Carambola.params.currentPost;
  }

  Carambola.setTimeoutNext = () => {
    const { unit, layout } = Carambola.params,
          activeElement = unit.querySelector(".carambola-active");

    if(!activeElement) return false;  
    const activeInterval = activeElement.dataset.interval;

    clearTimeout(Carambola.params.carouselTimeout);
    Carambola.params.carouselTimeout = setTimeout(() => {
      if(Carambola.detectIfInViewport(unit) && document.visibilityState === 'visible'){ 
        if(layout === 160 || layout === 152) Carambola.nextTweet();
      }
    }, activeInterval);
  }

  Carambola.unit160Actions = (action) => {
    const { unit, layout } = Carambola.params,
          { w, h, top, left } = Carambola.postScreenPosition(),
          activeIndex = parseInt(unit.querySelector(".carambola-active").getAttribute("rel")),
          activeItem = (Carambola.content?.Items) ? Carambola.content.Items[activeIndex] : Carambola.getDefaultContent()[activeIndex];

    let url;
    switch(action) {
      case "follow":
        url = `https://twitter.com/intent/follow?screen_name=${activeItem.user_display_name}`;
        break;
      case "like":
        url = `https://twitter.com/intent/like?tweet_id=${activeItem.tweet_id}`;
        break;      
      case "retweet":
        url = `https://twitter.com/intent/retweet?tweet_id=${activeItem.tweet_id}`;
        break;    
      case "tweet":
        url = `https://twitter.com/${activeItem.user_full_name}/status/${activeItem.tweet_id}`;
        break; 
      default:
        url = `https://twitter.com/intent/tweet?in_reply_to=${activeItem.tweet_id}&text=${action}`;
    }

    window.top.open(url, 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
  }

  Carambola.unitGoToInPopUp = (url) => {
    const { w, h, top, left } = Carambola.postScreenPosition();
    window.top.open(url, 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
  }

  Carambola.getFollowLink = (socialNetwork = 'carambola-social-x') => {
    var followHtmlObj = Carambola.createHtmlObject('div', 'carambola-follow'),
        followImg = Carambola.createHtmlObject('img', 'carambola-follow-image');
  
    switch (socialNetwork) {
      case 'carambola-social-tiktok':
        followImg.src = `${Carambola.params.cdn}/media/follow/tiktok_follow.svg`;
        break;
      case 'carambola-social-instagram':
        followImg.src = `${Carambola.params.cdn}/media/follow/instagram_follow.svg`;
        break;
      case 'carambola-social-youtube-shorts':
        followImg.src = `${Carambola.params.cdn}/media/follow/youtube_follow.svg`;
        break;
      default:
        followImg.src = `${Carambola.params.cdn}/media/follow/x_follow.svg`;
    }    
    
    followHtmlObj.textContent = "Follow us on";
    followHtmlObj.addEventListener('click', () => {
      Carambola.unitGoToInPopUp(Carambola.params.socialFollowLink);
      Carambola.log("FollowUs");
    });

    followHtmlObj.append(followImg);

    return followHtmlObj;
  }

  Carambola.follow = () => {
    const { socialFollowLink, socialFollowPlacement, unit } = Carambola.params, 
          classesToCheck = ['carambola-social-x', 'carambola-social-tiktok', 'carambola-social-youtube-shorts',  'carambola-social-instagram'];

    if(socialFollowLink && socialFollowPlacement){
      switch(socialFollowPlacement) {
        case "after_1_post":
        case "after_2_post":  
        case "after_3_post":
        case "after_4_post":  
        case "after_5_post":
          var elementNum =  parseInt(socialFollowPlacement.replace(/\D/g, "")) - 1,
                selectedElement = unit.querySelectorAll(".carambola-element.carambola-social-post")[elementNum];

          if(selectedElement && selectedElement.classList.contains("carambola-loaded") && !selectedElement.classList.contains("carambola-has-follow")) {
            selectedElement.classList.add("carambola-has-follow");
            const foundClass = classesToCheck.find(className => selectedElement.classList.contains(className));
            selectedElement.append(Carambola.getFollowLink(foundClass)); 
          }
          break;  
        case "after_every_1_post":
        case "after_every_2_post":  
        case "after_every_3_post":
        case "after_every_4_post":  
        case "after_every_5_post":   
          var elementNum =  parseInt(socialFollowPlacement.replace(/\D/g, ""));

          unit.querySelectorAll(".carambola-element.carambola-social-post").forEach((selectedElement, index) => {
            if ((index + 1) % elementNum === 0 && selectedElement && selectedElement.classList.contains("carambola-loaded") && !selectedElement.classList.contains("carambola-has-follow")) {
              selectedElement.classList.add("carambola-has-follow");
              const foundClass = classesToCheck.find(className => selectedElement.classList.contains(className));
              setTimeout(() => {selectedElement.append(Carambola.getFollowLink(foundClass));},1000); 
            }
          });
          break;                                     
      }
    }
  }

  Carambola.renderAds = () => {
    Carambola.params.render = true;
    switch(Carambola.params.layout) {
        case 211:
        case 161:
        case 163:  
          Carambola.unitAd211();
          break;  
        case 201:   
        case 202:
          Carambola.unitAd202();
          break;         
    }
  }

  Carambola.renderStyle = () => {
    const { layout, cdn, did, teleport } = Carambola.params, 
          style = document.createElement("style"), 
          linkStyle = document.createElement("link");

    style.className = `carambola-style carambola-style-layout-${layout}`;

    linkStyle.rel = "stylesheet";
    linkStyle.type = "text/css";
    linkStyle.className = `carambola-external-style carambola-external-style-layout-${layout}`;
    linkStyle.href = (window.top.location.host === "localhost:3000") ? `http://localhost:3000/css/layout_${layout}.min.css` : `${cdn}/css/layout_${layout}.min.css`;

    let htmlStyle = '';
          
    if(layout === 152) {
      htmlStyle = ` .carambola-layout-152 .carambola-tweet-title{background-color:${did===2902 ? '#F7750D':'#002282'}}.carambola-layout-152 .carambola-icon{z-index: 11; background-color:${did===2902 ? '#F7750D':'#002282'}}.carambola-layout-152 .carambola-icon:hover{background-color:${did===2902 ? '#53D337':'#021961'}}`;           
    }   

    htmlStyle += ` .carambola-lazyload-wrap > .twitter-tweet { display: none; }  .carambola-title{text-align:center;font-size:14px;line-height:30px;margin:5px auto;padding:0 10px;border-radius:5px;box-sizing:border-box; width:100% !important;}.carambola-follow-image{width:20px;margin:0 5px}.carambola-stickToBottom{position:absolute!important;top:auto!important;bottom:0!important;padding-right:0!important}`;

    if(did === 3259) htmlStyle += ` .carambola-wrap { margin: 10px auto !important; }`;

    if(Carambola?.params?.socialFollowAbtest === 1){
      htmlStyle += ` .carambola-follow { display: none !important; } `;
    }              

    style.innerHTML = htmlStyle;

    if(teleport) {
      window.top.document.head.append(linkStyle);
      window.top.document.head.append(style);
    }
    else {
      document.head.append(linkStyle);
      document.head.append(style);
    }
  }

  Carambola.scrollArrow = function() {
    const cbolaMouseScroll = document.createElement('div');
    cbolaMouseScroll.id = 'carambola-mouse-scroll';

    const cbolaMouse = document.createElement('div');
    cbolaMouse.className = 'carambola-mouse';

    const cbolaMouseIn = document.createElement('div');
    cbolaMouseIn.className = 'carambola-mouse-in';

    const tempDiv = document.createElement('div');
    for (let i = 1; i <= 3; i++) {
      const cbolaDownArrow = document.createElement('span');
      cbolaDownArrow.className = `carambola-down-arrow-${i}`;
      tempDiv.append(cbolaDownArrow);
    }

    cbolaMouse.append(cbolaMouseIn);
    cbolaMouseScroll.append(cbolaMouse);
    cbolaMouseScroll.append(tempDiv);

    return cbolaMouseScroll;
  }

  Carambola.message = function(clickUrl){
    const wrap = Carambola.params.unit.querySelector('.carambola-mobile-wrapper');
    if(wrap && wrap.querySelector('iframe')) wrap.querySelector('iframe').remove();
    if(wrap && wrap.querySelector('.transparent-top-div')) wrap.querySelector('.transparent-top-div').remove();
    if(wrap && wrap.querySelector('.transparent-bottom-div')) wrap.querySelector('.transparent-bottom-div').remove();
    if(wrap && wrap.querySelector('.carambola-pin-container')) wrap.querySelector('.carambola-pin-container').style.display = "none";

    const msg = document.createElement('div');
    msg.classList.add('carambola-mobile-msg');   
    msg.textContent = 'Wait! There’s more to discover';

    const msgSpan = document.createElement('span');
    msgSpan.classList.add('carambola-mobile-msg-sub-title'); 
    msgSpan.textContent = 'Are you sure you want to leave?';

    msg.append(msgSpan);

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('carambola-mobile-btn-wrap');

    const yes = document.createElement('button');
    yes.classList.add('carambola-mobile-btn-yes');
    yes.textContent = "Return";
    yes.addEventListener("click", (e)=> { Carambola.closeModal(e); Carambola.log("No"); }, false);

    const no = document.createElement('button');
    no.classList.add('carambola-mobile-btn-no');
    no.textContent = "yes, I’m sure";
    no.addEventListener("click", (e)=> { 
      const platform = (clickUrl.includes("pinterest")) ? "Pinterest" : null;
      const { w, h, top, left } = Carambola.postScreenPosition(platform);
      Carambola.closeModal(e); 
      Carambola.log("Yes"); 
      window.top.open(clickUrl, 'Social Media', `scrollbars=no, resizable=no, toolbar=no, location=no, width=${w}, height=${h}, top=${top}, left=${left}`);
    }, false);

    btnWrap.append(yes);
    btnWrap.append(no);
    msg.append(btnWrap);
    wrap.append(msg);
  }

  Carambola.closeModal = function(e){
    e.preventDefault();
    e.stopPropagation();
    const { unit, layout } = Carambola.params;

    unit.querySelector(".carambola-mobile-wrapper").remove();
    
    if(layout === 211 || layout === 201 || layout === 202 || layout === 161 || layout === 163) Carambola.scrollNext(unit.querySelector(".carambola-social-wrapper"));
  }

  Carambola.unitAd211 = () => {
    const unitWrap = Carambola.params.unit, { layout } = Carambola.params;

    const ad250 = Carambola.ads.filter(element => element.adType === "outOfFrame" && (element.size === "300x250" || element.size === "300x50" || element.size === "320x50"));
    if(ad250.length > 0){
      const currentAd = ad250[0], 
            adSizeArr = currentAd.size.split("x"),
            adWidth = parseInt(adSizeArr[0]),
            adHeight = parseInt(adSizeArr[1]),
            iframeClass = `carambola-bottom-ad-${Carambola.uniqueId()}`,
            adWrap = unitWrap.querySelector(`.carambola-vertical-ad`);

      if(adHeight === 50) {
          unitWrap.querySelector(".carambola-social-wrapper").style.height = "523px";
          unitWrap.querySelector(".carambola-vertical-ad-wrapper").style.height = "50px";
      } 

      Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass);
      
      if(currentAd.refresh) {
        const adIframe = unitWrap.querySelectorAll(`.${iframeClass}`);
        if(adIframe && adIframe.length > 0) {
          setInterval(()=>{ 
            adWrap.replaceChildren(); 
            Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass, true);
          }, currentAd.refresh * 1000);
        }
      }
      
      Carambola.stickyOutOfFrameAd(currentAd, adWrap);    
    }
  }

  Carambola.unitAd202 = () => {
    const unitWrap = Carambola.params.unit;

    const ad250 = Carambola.params.layout === 202 ? Carambola.ads.filter(element => element.adType === "outOfFrame" && element.size === "300x50") : Carambola.ads.filter(element => element.adType === "outOfFrame" && (element.size === "300x50" || element.size === "320x50"));
    if(ad250.length > 0){
      const currentAd = ad250[0], 
            adSizeArr = currentAd.size.split("x"),
            adWidth = parseInt(adSizeArr[0]),
            adHeight = parseInt(adSizeArr[1]),
            iframeClass = `carambola-bottom-ad-${Carambola.uniqueId()}`,
            adWrap = unitWrap.querySelector(`.carambola-vertical-ad`);       

      Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass);

      Carambola.stickyOutOfFrameAd(currentAd, adWrap);

      if(currentAd.refresh) {
        const adIframe = unitWrap.querySelectorAll(`.${iframeClass}`);
        if(adIframe && adIframe.length > 0) {
          setInterval(()=>{ 
            adWrap.replaceChildren(); 
            Carambola.writeDiv(currentAd, adWrap, currentAd.TagScript, adWidth, adHeight, iframeClass, true);
          }, currentAd.refresh * 1000);
        }
      }
    }
  }

  Carambola.stickyOutOfFrameAd = (adObj, adWrap) => {
    const supportLayouts = [201, 202, 211];
    if(supportLayouts.includes(Carambola.params.layout) && adObj?.sticky && adWrap){
      const bannerWrapper = Carambola.params.unit.querySelector('.carambola-wrap'),
            bannerSticky = adWrap.parentNode,
            placeholderAd = Carambola.createHtmlObject("div", "carambola-placeholder");
            
      placeholderAd.style.height = bannerSticky.offsetHeight + "px";
      placeholderAd.style.width = "100%";
  
      if (!bannerWrapper.querySelector(".carambola-placeholder")) bannerWrapper.append(placeholderAd);
      
      let fixedTimeout, prevScrollPos = window.scrollY;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const currentScrollPos = window.scrollY, isScrollingUp = currentScrollPos < prevScrollPos;
            if (entry.isIntersecting && entry.intersectionRect.top > 0) {
              const wrapperFullyVisible = entry.intersectionRect.height === entry.boundingClientRect.height;
  
              if (!wrapperFullyVisible) {
                if (entry.intersectionRect.height > bannerSticky.offsetHeight) {
                  bannerSticky.style.position = 'fixed';
                  bannerSticky.style.bottom = '0';
                  bannerSticky.style.top = 'auto';
                  bannerSticky.style.zIndex = '40';
                  bannerSticky.style.width = `${entry.target.offsetWidth}px`;
                  bannerSticky.style.paddingRight = "3px";
                  bannerSticky.style.boxSizing = "border-box";

                  clearTimeout(fixedTimeout);
                  fixedTimeout = setTimeout(() => {
                    bannerSticky.classList.add('carambola-stickToBottom');
                    bannerSticky.style.position = 'absolute';
                    bannerSticky.style.top = 'auto';
                    bannerSticky.style.bottom = '0';
                    bannerSticky.style.paddingRight = "0";
                  }, 3000);
                } else {
                  bannerSticky.style.position = 'absolute';
                  bannerSticky.style.top = '0';
                  bannerSticky.style.zIndex = '40';
                  bannerSticky.style.width = `${entry.target.offsetWidth}px`;
                  bannerSticky.style.paddingRight = "0";
                  if(!isScrollingUp) bannerSticky.classList.remove('carambola-stickToBottom');
                }
              } else {
                bannerSticky.style.position = 'absolute';
                bannerSticky.style.top = 'auto';
                bannerSticky.style.bottom = '0';
                bannerSticky.style.paddingRight = "0";
                bannerSticky.classList.remove('carambola-stickToBottom');
              }
            } else {
              bannerSticky.style.position = 'absolute';
              bannerSticky.style.top = 'auto';
              bannerSticky.style.bottom = '0';
              bannerSticky.style.paddingRight = "0";
              bannerSticky.classList.remove('carambola-stickToBottom');
            }

            prevScrollPos = currentScrollPos;
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: Array.from({ length: 101 }, (_, i) => i / 100)
        }
      );
  
      observer.observe(bannerWrapper);
    }
  };

  Carambola.inContentAdsList = () => {
    const ad300 = [], ad300Filter = Carambola.ads.filter(element => element.adType && element.location && element.adType.includes("inContent"));
    if(ad300Filter.length > 0){
      ad300Filter.forEach(item => {
        let locationArr = (item.location.indexOf(",") > 0) ? item.location.split(',').map(el => parseInt(el.replace(/\W/g,''))) : [parseInt(item.location.replace(/\W/g,''))]; 
        locationArr.forEach(el => {
          ad300[el] = item;
        });
      });
    }
    return ad300;
  }

  Carambola.uniqueId = () => {
    return Math.random().toString(36).slice(2, 9);
  }

  Carambola.writeDiv = (currentAd, container, code, width = 300, height = 250, iframeClass = 'carambola-ad-iframe', refresh = false) => {
    Carambola.writeAd(container, code, iframeClass, width, height, refresh, currentAd.adType);
  }

  Carambola.writeAd = (container, code, iframeClass, width, height, refresh, adType) => {
    const { layout } = Carambola.params,
          adWrap = document.createElement("div");

    adWrap.className = iframeClass;
    adWrap.style.width = `${width}px`;
    adWrap.style.minHeight = `${height}px`;
    adWrap.innerHTML = code;
    adWrap.addEventListener("click", ()=> { Carambola.log("ClickAd"); }, false);
    Carambola.setInnerHTML(adWrap);

    if((layout === 211 || layout === 201 || layout === 202 || layout === 162) && adType.includes("inContent")){
      const advertisement = document.createElement("span");
      advertisement.textContent = "Advertisement";
      advertisement.className = "carambola-title-advertisement";
      container.append(advertisement);
    }

    container.append(adWrap);
    
    if(!refresh) Carambola.params.adCount++;
  }

  Carambola.getParamsFromUrl = (url) => {
    let params = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      params[key.toLowerCase()] = value;
    });
    return params;
  };

  Carambola.setInnerHTML = (elm) => {
    const { teleport } = Carambola.params;
    Array.from(elm.querySelectorAll("script")).forEach(oldScriptEl => {
      const newScriptEl = document.createElement("script");
      
      let externalLink = false;
      Array.from(oldScriptEl.attributes).forEach( attr => {
        newScriptEl.setAttribute(attr.name, attr.value); 
        if(attr.name === "src"){
          externalLink = true;
        }
      });
      
      const scriptText = document.createTextNode(oldScriptEl.innerHTML);
      newScriptEl.appendChild(scriptText);
      
      if (externalLink){ 
        oldScriptEl.remove();
        if(!Carambola.files.includes(newScriptEl.src)) {
          Carambola.files.push(newScriptEl.src);
          try {            
            if(teleport) window.top.document.body.prepend(newScriptEl);
            else document.body.prepend(newScriptEl);
          } catch (error) {
            document.body.prepend(newScriptEl);
          }
        }
      }
      else {
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
      }
    });
  }

  Carambola.isMobile = () => {
    return /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(navigator.userAgent.toLowerCase()) && navigator.userAgent.search('PC') === -1;
  };

  Carambola.detectIfInViewport = (el) => {
    const { teleport } = Carambola.params;
    el = teleport ? el : Carambola.detectIfInIframe(el);
    const rect = el.getBoundingClientRect(), unitHeight = parseInt(rect.height - (20 * rect.height / 100)); 
    return (rect.top + unitHeight >= 0 && rect.left >= 0 && rect.right <= (window.top.innerWidth || document.documentElement.clientWidth) && rect.bottom - unitHeight <= (window.top.innerHeight || document.documentElement.clientHeight));
  }
  
  Carambola.detectIfInIframe = (el) => {
    return (window.location === window.parent.location) ? el : window.parent.frameElement || window.frameElement;
  }

  Carambola.init();
})();